import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { firebaseAuth } from "../../../providers/AuthProvider";
// import firebase from "firebase/compat/app";
import "firebase/functions";
import { DeleteIcon, InfoIcon } from "../../../Constants";
import "../../../assets/css/groups.css";
import { db } from "../../../firebase";
import { buildDealerOptions, filterDealerOption, formatDealerLabel, toDealerSelection } from "../../../utils/dealerOptions";
// import moment from "moment";
import DOMPurify from "dompurify";
import firebase from "firebase/compat/app";
import { JsonViewer } from "json-edit-react";
import moment from "moment-timezone";
import { QRCodeCanvas as QRCode } from "qrcode.react";
import Select from "react-select";
import { toast } from "react-toastify";
import "../../../assets/css/event.css";
import { CurrentEventDataContext } from "../CurrentEventDataContext";
import {
  appendCollapsedAdditionalFieldExpansion,
  duplicateAdditionalField,
  getAdditionalFieldNameValidationError,
  insertCollapsedAdditionalFieldExpansion,
  moveAdditionalField,
  moveAdditionalFieldExpansion,
  normalizeAdditionalFieldExpansion,
  removeAdditionalFieldExpansion,
} from "../../../utils/additionalFieldEditor";
import { stripUndefinedValues } from "../../../utils/firestoreData";
import {
  dealerOptInModeFlags,
  getDealerOptInMode,
} from "../../../utils/dealerOptIn";
import {
  normalizeModelInterestSelection,
  resolveModelInterestCatalog,
} from "../../../utils/modelInterest";
import { TestPaymentModeBanner } from "../../TestPaymentModeBanner";
import CampaignRequestLinkControl from "./CampaignRequestLinkControl";
import { campaignRequestMismatch, requiresApprovedCampaignRequest } from "../../../utils/capConfiguration";
import { isAssignedToEvent } from "../../../utils/eventAssignment";
import { EventAdditionalField } from "./EventAdditionalField";
import { CommerceRegistrationOptions } from "./CommerceRegistrationOptions";
import {
  CRM_DATA_FIELD_EDITOR_ROWS,
  EventCrmDataField,
} from "./EventCrmDataField";
import { EventCTAItem } from "./EventCTAItem";
import { ShortcodeReferencePanel } from "./ShortcodeReferencePanel";
import VisualEditorModal from "./VisualEditorModal";
// import { writeJSON } from "fs-extra";
const Event = () => {
  const { user } = useContext(firebaseAuth);
  const [help, setHelp] = useState({});
  const [floatingSave, setFloatingSave] = useState(false);
  const [endDateChange, setEndDateChange] = useState(false);
  const [settings, setSettings] = useState({
    mailboxes: [],
    waiverDefaultCopy: [],
    optInDefaultCopy: [],
  });
  const [eventData, setEventData] = useState(null);
  const originalEvent = useRef(null);
  const mounted = useRef(true);
  const [additionalFieldExpansion, setAdditionalFieldExpansion] = useState([]);
  const [ctaExpansion, setCTAExpansion] = useState([]);
  const { setCurrentEventData } = useContext(
    CurrentEventDataContext,
  );
  const [campaignCodes, setCampaignCodes] = useState([]);
  useState(false);
  const [dealers, setDealers] = useState([]);
  const [showModules, setShowModules] = useState([]);
  const [dealerOptions, setDealerOptions] = useState([]);
  const optInSelectRef = React.createRef();
  const waiverSelectRef = React.createRef();
  useState(true);
  const [editCopy, setEditCopy] = useState(null);
  const [userList, setUserList] = useState([]);
  // const [passcodeUserRefs, setPasscodeUserRefs] = useState([]);
  const [sessionData, setSessionData] = useState(null);
  const history = useNavigate();
  const alertRules = [
    "IncompleteWaiver",
    "IncompletePayment",
    "IsGuest",
    "Pending",
    "NotCheckedIn",
    "CheckedIn",
    "Completed",
    "Waitlist",
  ];
  const normalizePasscodeSettings = (data) => {
    if (!data || data.allowPasscodes) return data;
    return {
      ...data,
      allowMultiUsePasscodes: false,
      requireMultiUsePasscodes: false,
      allowSingleUsePasscodes: false,
    };
  };
  const [showOptIn, setShowOptIn] = useState(false);
  const [showWaiver, setShowWaiver] = useState(false);
  const [showSessions, setShowSessions] = useState(false);
  const { id } = useParams();
  const loadInit = async () => {
    let storageEventData = sessionStorage.getItem("eventData");
    console.log("loadInit");
    console.log(storageEventData);
    // if (storageEventData && (storageEventData === '' || storageEventData === 'undefined')) {
    //   history("/manage");
    //   return;
    // }
    let tmpEventData = null; //JSON.parse(storageEventData);
    // console.log(tmpEventData);
    if (tmpEventData && tmpEventData !== "") setEventData(tmpEventData);
    // let tmpEventData = currentEventData
    if (!tmpEventData || tmpEventData?.id !== id) {
      if (id) {
        let tmpUpdateEventData = await db.collection("events").doc(id).get();
        if (!tmpUpdateEventData.exists) {
          toast.error("Event not found. Reload the event list.");
          return;
        }
        tmpEventData = { ...tmpUpdateEventData.data(), id: tmpUpdateEventData.id };
      } else {
        let tmpEventId = await db.collection("events").doc().id;
        const newEvent = {
          id: tmpEventId,
          name: "New Event",
          email: "info",
          status: "Active",
          sortOrder: 0,
          hideOverlay: true,
          showFAQInline: false,
          showFAQInlineLanding: false,
          showTermsInline: false,
          showTermsInlineLanding: false,
          showLightboxAfterRegistration: false,
          constrainLightboxWidth: false,
          alternatingRowsStartRight: false,
          usersAllowed: [{ name: user.email }],
          dataFields: {
            experience: { visible: true, required: false },
            firstName: { visible: true, required: true },
            title: { visible: false, required: false },
            address1: { visible: false, required: false },
            city: { required: false, visible: false },
            dealer: { visible: false },
            email: { visible: true, required: true },
            lastName: { visible: true, required: true },
            modelInterest: { visible: false },
            phone: { visible: false },
            postal: { required: true, visible: true },
            purchaseTimeFrame: { visible: true },
            state: { required: false, visible: false },
          },
        };
        tmpEventData = newEvent;
      }
    }
    tmpEventData = normalizePasscodeSettings(tmpEventData);
    originalEvent.current = id ? tmpEventData : null;

    if (!mounted.current) return;
    if (tmpEventData) {
      setEventData(tmpEventData);
      setCurrentEventData(tmpEventData);
      sessionStorage.setItem("eventData", JSON.stringify(tmpEventData));
    } else {
      toast.error(
        "Select to edit or view registrations for an event before continuing..",
      );
      history("/manage");
      return;
    }
    let regInfo = await firebase.functions().httpsCallable("appV2/regCount");
    let result = await regInfo({ id: tmpEventData.id });
    if (!mounted.current) return;
    if (!result.data.error && tmpEventData) tmpEventData.regCount = result.data;

    if (!tmpEventData.dataFields) tmpEventData.dataFields = [];
    if (tmpEventData.createdAt && tmpEventData.createdAt.seconds) {
      tmpEventData.createdAt = new Date(
        tmpEventData.createdAt.seconds * 1000 +
          tmpEventData.createdAt.nanoseconds / 1000000,
      );
    } else if (tmpEventData.createdAt && tmpEventData.createdAt._seconds) {
      tmpEventData.createdAt = new Date(
        tmpEventData.createdAt._seconds * 1000 +
          tmpEventData.createdAt._nanoseconds / 1000000,
      );
    } else if (tmpEventData.createdAt) {
      tmpEventData.createdAt = new Date(tmpEventData.createdAt);
    }
    if (tmpEventData.updatedAt && tmpEventData.updatedAt.seconds)
      tmpEventData.updatedAt = new Date(
        tmpEventData.updatedAt.seconds * 1000 +
          tmpEventData.updatedAt.nanoseconds / 1000000,
      );
    else if (tmpEventData.updatedAt && tmpEventData.updatedAt._seconds)
      tmpEventData.updatedAt = new Date(
        tmpEventData.updatedAt._seconds * 1000 +
          tmpEventData.updatedAt._nanoseconds / 1000000,
      );
    else if (tmpEventData.updatedAt)
      tmpEventData.updatedAt = new Date(tmpEventData.updatedAt);
    // console.log(tmpEventData.additionalFields);
    setEventData({ ...tmpEventData });
    // console.log(tmpEventData.createdAt);
  };
  const getBaseUrl = () => {
    let url = window.location.protocol + "//" + window.location.hostname;
    if (window.location.port) {
      url += ":" + window.location.port;
    }
    return url + "/";
  };
  useEffect(() => {
    mounted.current = true;
    // if (!eventData || !eventData?.id) {
    //   toast.warning("Select to edit or view registrations for an event before continuing..");
    //   return <Redirect to="/manage" />;
    // }
    // let tmpShowModules = localStorage.getItem('showModules');
    // if (tmpShowModules) {
    //   setShowModules(JSON.parse(tmpShowModules));
    // } else {
    //   setShowModules({details:true,design:false,notifications:true,configuration:true,passcodes:false,capacities:false,leads:false,fields:false});
    // }
    loadInit();
    DOMPurify.setConfig({ ADD_ATTR: ["target"] });
    db.collection("settings")
      .doc("current")
      .get()
      .then((docRef) => {
        setSettings(docRef.data());
      });
    db.collection("dealers")
      .get()
      .then((qs) => {
        if (qs.docs.length > 0) {
          let tmpItems = [];
          qs.docs.forEach((item, index) => {
            let tmpItem = item.data();
            tmpItem.id = item.id;
            tmpItems.push(tmpItem);
          });
          setDealers(tmpItems);
          setDealerOptions([{ value: "", label: "No preference" },
            ...buildDealerOptions([], tmpItems, { includeNoPreference: false })]);
        }
      });
    firebase.functions().httpsCallable("appV2/listCampaignRequests")({})
      .then((result) => setCampaignCodes((result.data || [])
        .filter((item) => item.status === "approved" &&
          item.approvedConfig && !item.externalUse)
        .map((item) => ({ label: item.program + " - " + item.eventName,
          value: item }))))
      .catch(() => setCampaignCodes([]));
    if (user.role <= 1) {
      setTimeout(() => {
        var getUserList = firebase.functions().httpsCallable("appV2/userList");
        getUserList().then(async function (result) {
          setUserList(result.data);
        });
      }, 20);
    }
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      mounted.current = false;
      window.removeEventListener("scroll", handleScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intent: run-once init on mount; loadInit/user.role lookups should not re-fire mid-session
  }, []);
  const handleScroll = (e) => {
    let target = document.body;
    // console.log(target);
    let currentScrollY = window.scrollY;
    if (
      currentScrollY > 50 &&
      currentScrollY < target.clientHeight - window.innerHeight + 100
    ) {
      setFloatingSave(true);
    }
    if (currentScrollY >= target.clientHeight - window.innerHeight) {
      setFloatingSave(false);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (id && eventData?.id !== id) {
      toast.error("The editor does not match this event URL. Reload before saving.");
      return;
    }
    const assigned = isAssignedToEvent(eventData, user.email);
    if (Number(user.role) !== 1 && (!assigned ||
        (Number(user.role) > 2 && user.crmManager !== true))) {
      toast.error("You can change only events assigned to you.");
      return;
    }
    //check public
    //check group
    // if (!eventData?.groupId) {
    //   toast.error('You must select a group');
    //   return;
    // }
    let tmpEventData = normalizePasscodeSettings({ ...eventData });
    if (requiresApprovedCampaignRequest(tmpEventData, originalEvent.current) &&
      campaignRequestMismatch(tmpEventData,
        campaignCodes.find((option) => option.value.id === tmpEventData.capRequestId)?.value)) {
      toast.error("Reapply the approved campaign request before saving this event.");
      return;
    }
    const additionalFieldNameError = getAdditionalFieldNameValidationError(
      tmpEventData.additionalFields,
      fieldList,
    );
    if (additionalFieldNameError) {
      setAdditionalFieldExpanded(additionalFieldNameError.index, true);
      toast.error(additionalFieldNameError.message);
      return;
    }
    if (tmpEventData.publicUrl)
      tmpEventData.publicUrl = tmpEventData.publicUrl.toLowerCase();
    tmpEventData = stripUndefinedValues(tmpEventData);
    if (tmpEventData?.id && tmpEventData?.id !== 1) {
      console.log(tmpEventData.updatedAt);
      if (tmpEventData.updatedAt) {
        var checkEventData = await db
          .collection("events")
          .doc(tmpEventData?.id)
          .get();
        let tmpCheckUpdatedAt = checkEventData.data()?.updatedAt;
        if (
          tmpEventData.updatedAt &&
          tmpCheckUpdatedAt?.seconds &&
          tmpCheckUpdatedAt?.nanoseconds
        ) {
          let updatedAt = new Date(tmpEventData?.updatedAt);
          let checkUpdatedAt = new Date(
            tmpCheckUpdatedAt.seconds * 1000 +
              tmpCheckUpdatedAt.nanoseconds / 1000000,
          );
          console.log(checkUpdatedAt);
          console.log(tmpEventData?.updatedAt);
          if (checkUpdatedAt.getTime() > updatedAt.getTime()) {
            let continueSave = window.confirm(
              "This event has been saved by someone else since it was loaded.  Do you want to overwrite any changes made with this data?  If not, press cancel, and reload your event from the dashboard.",
            );
            if (continueSave) console.log("User overwrite previous save.");
            else return;
          }
        }
      }
      if (!tmpEventData.createdAt || isNaN(tmpEventData.createdAt)) {
        tmpEventData.createdAt =
          firebase.firestore.FieldValue.serverTimestamp();
      }
      tmpEventData.updatedAt = firebase.firestore.FieldValue.serverTimestamp();
      console.log(tmpEventData);
      db.collection("events")
        .doc(tmpEventData?.id)
        .set(tmpEventData)
        .then(() => {
          db.collection("events")
            .doc(tmpEventData?.id)
            .get()
            .then((doc) => {
              if (!doc.exists) {
                console.log("No such document!"); //Error
              } else {
                let evtData = doc.data();
                if (evtData.createdAt)
                  evtData.createdAt = new Date(
                    evtData.createdAt.seconds * 1000 +
                      evtData.createdAt.nanoseconds / 1000000,
                  );
                if (evtData.updatedAt)
                  evtData.updatedAt = new Date(
                    evtData.updatedAt.seconds * 1000 +
                      evtData.updatedAt.nanoseconds / 1000000,
                  );
                setEventData(evtData);
                setCurrentEventData(evtData);
                sessionStorage.setItem("eventData", JSON.stringify(evtData));
                //check if evtData.endDate is not null or empty and can be connverted to a valid date
                let tmpEndDate = evtData.endDate;
                if (
                  endDateChange &&
                  tmpEndDate &&
                  tmpEndDate !== "" &&
                  !isNaN(new Date(tmpEndDate))
                ) {
                  let exp = moment(evtData.endDate).clone().add(91, "days");

                  db.collection("registrations")
                    .where("eventId", "==", evtData.id)
                    .get()
                    .then(function async(querySnapshot) {
                      let len = querySnapshot.docs.length;
                      if (len > 0) {
                        toast.warning(
                          "Updating registration expirations please wait to see event saved successfully message.",
                          10000,
                        );
                        for (let i = 0; i < len; i++) {
                          querySnapshot.docs[i].ref
                            .update({
                              expiration: exp.toDate(),
                              email: querySnapshot.docs[i].data().email
                                ? querySnapshot.docs[i]
                                    .data()
                                    .email.toLowerCase()
                                : "",
                            })
                            .then(function () {
                              // console.log("Document " + (i + 1) + " of " + len + " successfully updated!");
                              if (i === len - 1) {
                                setEventData(evtData);
                                setCurrentEventData(evtData);
                                sessionStorage.setItem(
                                  "eventData",
                                  JSON.stringify(evtData),
                                );
                                toast.success("Event saved successfully.");
                              }
                            })
                            .catch(function (error) {
                              // The document probably doesn't exist.
                              console.error("Error updating document: ", error);
                            });
                        }
                      } else {
                        setEventData(tmpEventData);
                        setCurrentEventData(tmpEventData);
                        sessionStorage.setItem(
                          "eventData",
                          JSON.stringify(tmpEventData),
                        );
                        toast.success("Event saved successfully.");
                      }
                      // });
                      // console.log("All documents successfully updated.");
                    })
                    .catch(function (error) {
                      console.log("Error getting documents: ", error);
                      setEventData(tmpEventData);
                      setCurrentEventData(tmpEventData);
                      sessionStorage.setItem(
                        "eventData",
                        JSON.stringify(tmpEventData),
                      );
                      toast.success("Event saved successfully.");
                    });
                } else {
                  setEventData(evtData);
                  setCurrentEventData(evtData);
                  sessionStorage.setItem("eventData", JSON.stringify(evtData));
                  console.log();
                  toast.success("Event saved successfully.");
                }
              }
            })
            .catch(function (error) {
              console.error("Error adding document: ", error);
            });
        })
        .catch(function (error) {
          console.error("Error adding document: ", error);
        });
    } else {
      tmpEventData.createdAt = firebase.firestore.FieldValue.serverTimestamp();
      tmpEventData.updatedAt = firebase.firestore.FieldValue.serverTimestamp();
      db.collection("events")
        .add(tmpEventData)
        .then((docRef) => {
          setEventData({ ...tmpEventData, id: docRef.id });
          let tmpEvent = tmpEventData;
          tmpEvent.id = docRef.id;
          setEventData(tmpEvent);
          setCurrentEventData(tmpEvent);
          sessionStorage.setItem("eventData", JSON.stringify(tmpEvent));
          toast.success("Event saved successfully.");
        })
        .catch(function (error) {
          console.error("Error adding document: ", error);
        });
    }
  };
  const csvJSON = (text, quoteChar = '"', delimiter = ",") => {
    var rows = text.split("\n");
    var headers = rows[0].split(",");
    const regex = new RegExp(
      `\\s*(${quoteChar})?(.*?)\\1\\s*(?:${delimiter}|$)`,
      "gs",
    );
    const match = (line) =>
      [...line.matchAll(regex)].map((m) => m[2]).slice(0, -1);
    var lines = text.split("\n");
    const heads = headers ?? match(lines.shift());
    lines = lines.slice(1);
    return lines.map((line) => {
      console.log(line);
      return match(line).reduce((acc, cur, i) => {
        // replace blank matches with `null`
        let val = cur.length <= 0 ? null : Number(cur) || cur;
        const key = heads[i] ?? `{i}`;
        if (key === "id" || key === "itemIndex" || key === "reserved") {
          val = +val;
        }
        return { ...acc, [key]: val };
      }, {});
    });
  };
  const handleCSVChange = async (e) => {
    if (
      window.confirm(
        "This will replace any existing sessions, are you sure you want to continue?",
      )
    ) {
      console.log(e.target.value);
      let jsonData = csvJSON(e.target.value);
      // console.log(jsonData);
      setEventData({
        ...eventData,
        sessions: jsonData,
      });
      alert("Sessions updated successfully.");
    } else {
      alert("Cancelled");
    }
  };
  const handleChange = (e) => {
    if (e.target.name === "endDate") {
      setEndDateChange(true);
    }
    if (e.target.name === "publicUrl") {
      if (e.target.value) {
        e.target.value = e.target.value.toLowerCase().trim();
      }
    }
    if (e.target.name === "groupId") {
      setEventData({
        ...eventData,
        [e.target.name]: e.target.value,
        groupName: e.target.options[e.target.selectedIndex].text,
      });
    } else {
      setEventData({
        ...eventData,
        [e.target.name]: e.target.value,
      });
      console.log(eventData);
    }
  };
  const downloadPNG = (e) => {
    console.log(e);
    let c = document.getElementById("qr-code").firstChild;
    var a = document.createElement("a");
    a.href = c.toDataURL("image/png");
    a.download = "qr-code.png";
    a.click();
  };
  const downloadRegPNG = (e) => {
    console.log(e);
    let c = document.getElementById("qr-code-reg").firstChild;
    var a = document.createElement("a");
    a.href = c.toDataURL("image/png");
    a.download = "qr-code-reg.png";
    a.click();
  };
  const downloadGalleryPNG = (e) => {
    console.log(e);
    let c = document.getElementById("qr-code-gallery").firstChild;
    var a = document.createElement("a");
    a.href = c.toDataURL("image/png");
    a.download = "qr-code-gallery.png";
    a.click();
  };
  const fieldList = [
    "id",
    "eventId",
    "company",
    "title",
    "firstName",
    "lastName",
    "email",
    "phone",
    "address1",
    "address2",
    "city",
    "state",
    "postal",
    "country",
    "experience",
    "purchaseTimeFrame",
    "dealer",
    "modelInterest",
    "adyenResultCode",
    "adyenRefusalReason",
    "adyenRef",
    "adyenRefDate",
    "adyenLink",
    "adyenLinkId",
    "adyenLinkExpire",
    "status",
    "adyenPayemntStatus",
    "hasWaiver",
    "createdAt",
    "updatedAt",
    "leadSent",
  ];
  const shortcodeFieldList = [
    ...new Set(
      [
        ...fieldList,
        ...(eventData?.additionalFields || []).map((field) => field.fieldName),
        "guestFirstName",
        "guestLastName",
        "guestEmail",
        "guestPhone",
        "passcodeLabel",
        "passcodeEmail",
        "passcodeDescription",
        "passcodeDetails",
        "passcode",
        "qrCode",
        "qrGuestCode",
        "checkoutSummary",
      ].filter(Boolean),
    ),
  ];
  const uploadCloudinary = (
    file,
    pubId,
    folder,
    key,
    transformation,
    list,
    i,
    field,
  ) => {
    //uploadCloudinary(base64, eventData?.id + "_" + x + "_" + i, "/pcna/ezentrum/" + eventData?.id + "/", x + i, null, true, i);
    let uploadData = {
      file: file,
      public_id: pubId,
      folder: folder,
      transformation: transformation,
    };
    var upload = firebase.functions().httpsCallable("appV2/uploadCloudinary");
    upload(uploadData)
      .then((result) => {
        if (result?.data.message) {
          toast.warning(result?.data.message);
          return "";
        } else {
          toast.success("Image upload successful.");
          let tmpInputs = eventData;
          let u = result.data.url;
          console.log(u);
          console.log(list);
          console.log(key);
          console.log("======");
          //.split("/");
          // u.splice(6,1);
          // u = u.join("/");
          if (!list) tmpInputs[key] = u;
          let img = document.getElementById(key);
          console.log(img);
          console.log(key);
          img.src = img.src + "?v=" + Date.now(); // trick browser into reload
          if (!list) {
            setEventData({ ...tmpInputs });
            db.collection("events").doc(tmpInputs.id).set(tmpInputs);
            setEventData(tmpInputs);
            setCurrentEventData(tmpInputs);
            sessionStorage.setItem("eventData", JSON.stringify(tmpInputs));
          } else {
            let tmpImages = eventData[list];
            if (!field) {
              tmpImages[i] = u;
              console.log(tmpImages);
              setEventData({ ...eventData, tmpImages: tmpImages });
            } else {
              console.log(tmpImages);
              tmpImages[i][field] = u;
            }
            setEventData({ ...eventData, tmpImages: tmpImages });
          }
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.message);
      });
  };
  const handleChangeItem = useCallback((idkey, value) => {
    // console.log(idkey,value);
    // let tmpInputs = {...eventData};
    // tmpInputs[idkey] = value;
    // setEventData(tmpInputs);
    // // console.log(tmpInputs);
    // setEventData({...eventData,[idkey]:value});
    setEventData(value);
  }, []);
  const removeCloudinary = (pubId, key, disableNotifications) => {
    var remove = firebase.functions().httpsCallable("appV2/removeCloudinary");
    remove(pubId)
      .then((result) => {
        if (result?.data.message) {
          toast.warning(result?.data.message);
          return "";
        } else {
          if (!disableNotifications) toast.success("Image removal successful.");
          let tmpInputs = eventData;
          if (key) {
            tmpInputs[key] = "";
            let img = document.getElementById(key);
            // remove element?
            setEventData(tmpInputs);
            db.collection("events").doc(tmpInputs.id).set(tmpInputs);
            setEventData(tmpInputs);
            setCurrentEventData(tmpInputs);
            sessionStorage.setItem("eventData", JSON.stringify(tmpInputs));
          }
        }
      })
      .catch((error) => {
        console.log(error);
        if (!disableNotifications) toast.error(error.message);
      });
  };
  const removeBannerImage = () => {
    removeCloudinary(
      "pcna/ezentrum/" + eventData?.id + "/" + eventData?.id + "_banner",
      "bannerImage",
    );
    setEventData({ ...eventData, bannerImage: "" });
  };
  const removeEmailBannerImage = () => {
    removeCloudinary(
      "pcna/ezentrum/" + eventData?.id + "/" + eventData?.id + "_banner_email",
      "emailBannerImage",
    );
    setEventData({ ...eventData, bannerEmailImage: "" });
  };
  const removeLogoImage = () => {
    removeCloudinary(
      "pcna/ezentrum/" + eventData?.id + "/" + eventData?.id + "_logo",
      "logoImage",
    );
    setEventData({ ...eventData, logoImage: "" });
  };
  const removeMobileBannerImage = () => {
    setEventData({ ...eventData, mobileBannerImage: "" });
    removeCloudinary(
      "pcna/ezentrum/" + eventData?.id + "/" + eventData?.id + "_mobile_banner",
      "mobileBannerImage",
    );
  };
  const removeMobileEmailBannerImage = () => {
    setEventData({ ...eventData, mobileEmailBannerImage: "" });
    removeCloudinary(
      "pcna/ezentrum/" +
        eventData?.id +
        "/" +
        eventData?.id +
        "_mobile_email_banner",
      "mobileEmailBannerImage",
    );
  };
  const handleFileRead = async (event) => {
    console.log("3");
    const file = event.target.files[0];
    const base64 = await convertBase64(file);
    uploadCloudinary(
      base64,
      eventData?.id + "_banner",
      "/pcna/ezentrum/" + eventData?.id + "/",
      "bannerImage",
      { crop: "fill", height: 580, width: 1600 },
    );
  };
  const handleEmailFileRead = async (event) => {
    const file = event.target.files[0];
    const base64 = await convertBase64(file);
    uploadCloudinary(
      base64,
      eventData?.id + "_email_banner",
      "/pcna/ezentrum/" + eventData?.id + "/",
      "emailBannerImage",
      { crop: "fill", width: 800 },
    );
  };
  const handleLogoFileRead = async (event) => {
    const file = event.target.files[0];
    const base64 = await convertBase64(file);
    uploadCloudinary(
      base64,
      eventData?.id + "_logo",
      "/pcna/ezentrum/" + eventData?.id + "/",
      "logoImage",
    );
  };
  const handleMobileFileRead = async (event) => {
    console.log("4");
    const file = event.target.files[0];
    const base64 = await convertBase64(file);
    uploadCloudinary(
      base64,
      eventData?.id + "_mobile_banner",
      "/pcna/ezentrum/" + eventData?.id + "/",
      "mobileBannerImage",
      { crop: "fill", width: 800 },
    );
  };
  const handleMobileEmailFileRead = async (event) => {
    const file = event.target.files[0];
    const base64 = await convertBase64(file);
    uploadCloudinary(
      base64,
      eventData?.id + "_mobile_email_banner",
      "/pcna/ezentrum/" + eventData?.id + "/",
      "mobileEmailBannerImage",
      { crop: "fill", height: 600, width: 800 },
    );
  };
  const handleGalleryImageRead = async (event, i) => {
    const file = event.target.files[0];
    const base64 = await convertBase64(file);
    uploadCloudinary(
      base64,
      eventData?.id + "_galleryImage_" + i,
      "/pcna/ezentrum/" + eventData?.id + "/",
      "galleryImage" + i,
      null,
      "galleryImages",
      i,
    );
  };
  const handleListChange = async (event, i, x, checkbox, v) => {
    let tmpList = eventData[x];
    if (event.target.name === "fieldName");
    if (fieldList.indexOf(event.target.value) >= 0) {
      toast.error("Invalid field name, field already in use.");
      return;
    }
    let val = v
      ? v
      : checkbox
        ? event.target.checked
        : event.target.value
          ? event.target.value
          : "";
    tmpList[i] = { ...tmpList[i], [event.target.name]: val };
    setEventData({ ...eventData, tmpList: tmpList });
  };
  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };
  useEffect(() => {
    if (!user.isAuthenticated) {
      history("/manage/sign-in");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intent: re-check auth only on user change; history (react-router navigate) is stable across renders
  }, [user]);
  useEffect(() => {
    try {
      setSessionData(eventData?.sessions ? eventData?.sessions : []);
    } catch (e) {
      console.log("error", e);
    }
  }, [eventData?.sessions]);
  const moveCard = useCallback(
    (dragIndex, hoverIndex) => {
      const currentItems = eventData?.ctaList || [];

      setEventData({
        ...eventData,
        ctaList: moveAdditionalField(currentItems, dragIndex, hoverIndex),
      });
      setCTAExpansion((currentExpansion) =>
        moveAdditionalFieldExpansion(
          currentExpansion,
          currentItems.length,
          dragIndex,
          hoverIndex,
          false,
        ),
      );
    },
    [eventData],
  );
  const setCTAExpanded = (index, expanded) => {
    setCTAExpansion((currentExpansion) => {
      const nextExpansion = normalizeAdditionalFieldExpansion(
        currentExpansion,
        eventData?.ctaList?.length || 0,
        false,
      );
      nextExpansion[index] = expanded;
      return nextExpansion;
    });
  };
  const setAllCTAsExpanded = (expanded) => {
    setCTAExpansion(Array(eventData?.ctaList?.length || 0).fill(expanded));
  };
  const addCTA = () => {
    const currentItems = eventData?.ctaList || [];

    setEventData({ ...eventData, ctaList: [...currentItems, {}] });
    setCTAExpansion((currentExpansion) =>
      appendCollapsedAdditionalFieldExpansion(
        currentExpansion,
        currentItems.length,
        false,
      ),
    );
  };
  const removeCTA = (index) => {
    const currentItems = eventData?.ctaList || [];

    setEventData({
      ...eventData,
      ctaList: currentItems.filter((_, itemIndex) => itemIndex !== index),
    });
    setCTAExpansion((currentExpansion) =>
      removeAdditionalFieldExpansion(
        currentExpansion,
        currentItems.length,
        index,
        false,
      ),
    );
  };
  const moveField = useCallback(
    (dragIndex, hoverIndex) => {
      const currentFields = eventData?.additionalFields || [];
      const movedFields = moveAdditionalField(
        currentFields,
        dragIndex,
        hoverIndex,
      );

      setEventData({ ...eventData, additionalFields: movedFields });
      setAdditionalFieldExpansion((currentExpansion) =>
        moveAdditionalFieldExpansion(
          currentExpansion,
          currentFields.length,
          dragIndex,
          hoverIndex,
        ),
      );
    },
    [eventData],
  );
  const setAdditionalFieldExpanded = (index, expanded) => {
    setAdditionalFieldExpansion((currentExpansion) => {
      const nextExpansion = normalizeAdditionalFieldExpansion(
        currentExpansion,
        eventData?.additionalFields?.length || 0,
      );
      nextExpansion[index] = expanded;
      return nextExpansion;
    });
  };
  const setAllAdditionalFieldsExpanded = (expanded) => {
    setAdditionalFieldExpansion(
      Array(eventData?.additionalFields?.length || 0).fill(expanded),
    );
  };
  const addAdditionalField = () => {
    const currentFields = eventData?.additionalFields || [];

    setEventData({
      ...eventData,
      additionalFields: [...currentFields, {}],
    });
    setAdditionalFieldExpansion((currentExpansion) =>
      appendCollapsedAdditionalFieldExpansion(
        currentExpansion,
        currentFields.length,
      ),
    );
  };
  const removeAdditionalField = (index) => {
    const currentFields = eventData?.additionalFields || [];
    const removedFieldName = currentFields[index]?.fieldName;
    const additionalFields = currentFields
      .filter((field, fieldIndex) => fieldIndex !== index)
      .map((field) => {
        const cleanedField = { ...field };

        if (Array.isArray(field.commerceItemPrerequisites)) {
          cleanedField.commerceItemPrerequisites =
            field.commerceItemPrerequisites.filter(
              (fieldName) => fieldName !== removedFieldName,
            );
        }
        if (Array.isArray(field.commerceItemHidePrerequisites)) {
          cleanedField.commerceItemHidePrerequisites =
            field.commerceItemHidePrerequisites.filter(
              (fieldName) => fieldName !== removedFieldName,
            );
        }

        return cleanedField;
      });

    setEventData({ ...eventData, additionalFields });
    setAdditionalFieldExpansion((currentExpansion) =>
      removeAdditionalFieldExpansion(
        currentExpansion,
        currentFields.length,
        index,
      ),
    );
  };
  const duplicateField = (index) => {
    const currentFields = eventData?.additionalFields || [];
    const additionalFields = duplicateAdditionalField(currentFields, index);

    setEventData({ ...eventData, additionalFields });
    setAdditionalFieldExpansion((currentExpansion) =>
      insertCollapsedAdditionalFieldExpansion(
        currentExpansion,
        currentFields.length,
        index + 1,
      ),
    );
  };
  // useEffect(() => {
  //   eventData?.multiUsePasscodes?.map((x, i) => {
  //     let tmpPasscodeUserRefs = passcodeUserRefs;
  //     tmpPasscodeUserRefs[i] = React.createRef();
  //     setPasscodeUserRefs(tmpPasscodeUserRefs);
  //   });
  // }, [eventData]);
  const updateShowModules = (module, value) => {
    let tmpShowModules = { ...showModules };
    tmpShowModules[module] = value;
    setShowModules(tmpShowModules);
    localStorage.setItem("showModules", JSON.stringify(tmpShowModules));
  };
  const labelCls = "block text-sm font-medium text-zinc-700 dark:text-zinc-300";
  const inputCls = "mt-2 block w-full rounded-md bg-zinc-50 px-3 py-2 text-sm text-zinc-900 shadow-sm ring-1 ring-inset ring-zinc-300 placeholder:text-zinc-400 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-zinc-900 disabled:cursor-not-allowed disabled:opacity-60 dark:bg-zinc-800 dark:text-zinc-100 dark:ring-white/10 dark:placeholder:text-zinc-500 dark:focus:ring-white";
  const primaryBtnCls = "inline-flex items-center justify-center rounded-md bg-zinc-900 px-3 py-2 text-sm font-semibold text-zinc-50 shadow-sm hover:bg-zinc-800 dark:bg-white dark:text-zinc-900 dark:hover:bg-zinc-100";
  const secondaryBtnCls = "inline-flex items-center justify-center rounded-md bg-zinc-50 px-3 py-2 text-sm font-semibold text-zinc-900 ring-1 ring-inset ring-zinc-300 hover:bg-zinc-100 dark:bg-zinc-800 dark:text-zinc-100 dark:ring-white/10 dark:hover:bg-zinc-700";
  const linkBtnCls = "inline-flex items-center text-sm font-medium text-zinc-700 underline-offset-2 hover:text-zinc-900 hover:underline dark:text-zinc-300 dark:hover:text-zinc-100";
  const formGroupCls = "mb-4";
  const cardCls = "mb-4 rounded-lg bg-zinc-50 shadow-sm ring-1 ring-zinc-200 dark:bg-zinc-900 dark:ring-zinc-700";
  const cardHeaderCls = "flex cursor-pointer flex-row items-center justify-between border-b border-zinc-200 px-4 py-3 dark:border-zinc-700";
  const cardBodyCls = "p-4";
  const assignedToCurrentUser = isAssignedToEvent(eventData, user.email);
  const canEditCurrentEvent = Number(user.role) === 1 || (assignedToCurrentUser &&
    (Number(user.role) <= 2 || user.crmManager === true));
  return (
    <div className="mx-auto w-full max-w-7xl px-0 sm:px-4">
      <h1 className="text-2xl font-bold text-zinc-900 dark:text-zinc-100">
        {eventData?.sysname ? eventData?.sysname : eventData?.name}
      </h1>
      {user.crmManager === true && !canEditCurrentEvent &&
        <p className="mt-2 rounded bg-amber-100 p-3 text-sm text-amber-900">
          View only. You can edit events assigned to you.</p>}
      <TestPaymentModeBanner className="mt-3" eventData={eventData} />
      {eventData?.publicUrl && (eventData?.allowPublic || eventData?.allowReg) && (
        <nav
          aria-label="Event page links"
          className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-2"
        >
          {eventData.allowPublic && (
            <a
              className={linkBtnCls}
              href={getBaseUrl() + eventData.publicUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Landing Page
            </a>
          )}
          {eventData.allowReg && (
            <a
              className={linkBtnCls}
              href={getBaseUrl() + "register/" + eventData.publicUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Registration Page
            </a>
          )}
        </nav>
      )}
      <div className="py-2"></div>
      <div className={cardCls}>
        <div
          className={cardHeaderCls}
          onClick={() => {
            updateShowModules("details", !showModules.details);
          }}
        >
          <h2>Event Details</h2>
          <div>
            <span className={showModules.details ? "pe-3 text-xs font-bold" : "pe-3 text-xs"}>
              Show
            </span>
            <span className={!showModules.details ? "text-xs font-bold" : "text-xs"}>Hide</span>
          </div>
        </div>
        {showModules.details && (
          <div className={cardBodyCls}>
            <div className="flex flex-wrap gap-4">
              <div className="w-full">
                <div className={formGroupCls}>
                  <label
                    className={labelCls + " form-help"}
                    onClick={() => {
                      setHelp({ ...help, sysname: !help.sysname });
                    }}
                  >
                    Event System Name{" "}
                    <i className="xs">
                      <InfoIcon />
                    </i>
                  </label>
                  <div className={help.sysname ? "fs-xs" : "hidden"}>
                    System Name for the event.
                  </div>
                  <input
                    type="text"
                    id="sysname"
                    name="sysname"
                    value={eventData?.sysname || ""}
                    onChange={handleChange}
                    className={inputCls}
                  />
                </div>
                <div className={formGroupCls}>
                  <label
                    className={labelCls + " form-help"}
                    onClick={() => {
                      setHelp({ ...help, eventName: !help.eventName });
                    }}
                  >
                    Event Name{" "}
                    <i className="xs">
                      <InfoIcon />
                    </i>
                  </label>
                  <div className={help.eventName ? "fs-xs" : "hidden"}>
                    Name for the event.
                  </div>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={eventData?.name || ""}
                    onChange={handleChange}
                    className={inputCls}
                  />
                </div>
                <div className={formGroupCls}>
                  <label
                    className={labelCls + " form-help"}
                    onClick={() => {
                      setHelp({ ...help, subtitle: !help.subtitle });
                    }}
                  >
                    Event Subtitle{" "}
                    <i className="xs">
                      <InfoIcon />
                    </i>
                  </label>
                  <div className={help.subtitle ? "fs-xs" : "hidden"}>
                    Subtitle for the event.
                  </div>
                  <input
                    type="text"
                    id="subtitle"
                    name="subtitle"
                    value={eventData?.subtitle || ""}
                    onChange={handleChange}
                    className={inputCls}
                  />
                </div>
                <div className="flex flex-wrap gap-4">
                  <div className="flex-1 min-w-0">
                    <div className={formGroupCls}>
                      <label className={labelCls}>Start Date</label>
                      <input
                        type="date"
                        id="startDate"
                        name="startDate"
                        value={eventData?.startDate || ""}
                        onChange={handleChange}
                        className={inputCls}
                      />
                    </div>
                  </div>
                  <div className="flex-1 min-w-0">
                    {!eventData?.ongoingEvent && (
                      <div className={formGroupCls}>
                        <label className={labelCls}>End Date</label>
                        <input
                          type="date"
                          id="endDate"
                          name="endDate"
                          value={eventData?.endDate || ""}
                          onChange={handleChange}
                          className={inputCls}
                        />
                      </div>
                    )}
                  </div>
                </div>
                <div className={formGroupCls}>
                  <label className="checkbox-container">
                    Ongoing Event (no end date)
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        if (!e.target.checked) {
                          setEventData({
                            ...eventData,
                            ongoingEvent: e.target.checked,
                          });
                        } else {
                          setEventData({
                            ...eventData,
                            ongoingEvent: e.target.checked,
                            endDate: "",
                          });
                        }
                      }}
                      id="ongoingEvent"
                      name="ongoingEvent"
                      value="true"
                      checked={eventData?.ongoingEvent || false}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                <div className={formGroupCls}>
                  <label className={labelCls}>
                    Allowed Users{" "}
                    {eventData?.allowedUsers && eventData?.allowedUsers !== ""
                      ? "(comma separated addresses)"
                      : ""}
                  </label>
                  {user.role <= 1 ? (
                    <>
                      {!eventData?.allowedUsers ||
                      eventData?.allowedUsers === "" ? (
                        <Select
                          classNamePrefix="manage-select"
                          isMulti
                          options={userList}
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.id || option.uid || option.email || option.name}
                          value={eventData?.usersAllowed || []}
                          onChange={(selectedList) => {
                            setEventData({
                              ...eventData,
                              usersAllowed: selectedList || [],
                            });
                          }}
                        />
                      ) : (
                        <input
                          type="text"
                          disabled={user.role > 1}
                          id="allowedUsers"
                          name="allowedUsers"
                          value={eventData?.allowedUsers || ""}
                          onChange={handleChange}
                          className={inputCls}
                        />
                      )}
                    </>
                  ) : (
                    <div>
                      {eventData?.usersAllowed?.map((x, i) => {
                        return (
                          <span key={i}>
                            {x.name}
                            {i < eventData?.usersAllowed.length - 1 ? "," : ""}
                          </span>
                        );
                      })}
                    </div>
                  )}
                </div>
                <div className={formGroupCls}>
                  <label className={labelCls}>Status</label>
                  <select
                    className={inputCls}
                    id="status"
                    name="status"
                    onChange={handleChange}
                    value={eventData?.status}
                  >
                    <option value="Active">Active</option>
                    <option value="Archived">Archived</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className={cardCls}>
        <div
          className={cardHeaderCls}
          onClick={() => {
            updateShowModules("design", !showModules.design);
          }}
        >
          <h2>Event Design</h2>
          <div>
            <span className={showModules.design ? "pe-3 text-xs font-bold" : "pe-3 text-xs"}>
              Show
            </span>
            <span className={!showModules.design ? "text-xs font-bold" : "text-xs"}>Hide</span>
          </div>
        </div>
        {showModules.design && (
          <div className={cardBodyCls}>
            <div className={formGroupCls}>
              <label className="checkbox-container">
                Enable public landing page?
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setEventData({
                      ...eventData,
                      allowPublic: e.target.checked,
                    });
                  }}
                  id="allowPublic"
                  name="allowPublic"
                  value="true"
                  checked={eventData?.allowPublic || false}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            <div className={formGroupCls}>
              <label className="checkbox-container">
                Enable Registration?
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setEventData({
                      ...eventData,
                      allowReg: e.target.checked,
                    });
                  }}
                  id="allowReg"
                  name="allowReg"
                  value="true"
                  checked={eventData?.allowReg || false}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            <div className={formGroupCls}>
              <label className="checkbox-container">
                Enable FAQ for event.
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setEventData({
                      ...eventData,
                      allowFAQ: e.target.checked,
                    });
                  }}
                  id="allowFAQ"
                  name="allowFAQ"
                  checked={eventData?.allowFAQ || false}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            <div className={eventData?.allowFAQ ? formGroupCls : "hidden"}>
              <label className="checkbox-container">
                Show FAQ inline at the end of the Event page.
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setEventData({
                      ...eventData,
                      showFAQInlineLanding: e.target.checked,
                      ...(e.target.checked ? { showFAQInline: false } : {}),
                    });
                  }}
                  id="showFAQInlineLanding"
                  name="showFAQInlineLanding"
                  checked={eventData?.showFAQInlineLanding || false}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            <div className={eventData?.allowFAQ ? formGroupCls : "hidden"}>
              <label className="checkbox-container">
                Show FAQ inline at the end of the Register page.
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setEventData({
                      ...eventData,
                      showFAQInline: e.target.checked,
                      ...(e.target.checked
                        ? { showFAQInlineLanding: false }
                        : {}),
                    });
                  }}
                  id="showFAQInline"
                  name="showFAQInline"
                  checked={eventData?.showFAQInline || false}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            <div className={eventData?.allowFAQ ? formGroupCls : "hidden"}>
              <label className="checkbox-container">
                Show Health and Safety Banner for event.
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setEventData({
                      ...eventData,
                      allowCovidBanner: e.target.checked,
                    });
                  }}
                  id="allowCovidBanner"
                  name="allowCovidBanner"
                  checked={eventData?.allowCovidBanner}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            <div className={formGroupCls}>
              <label className="checkbox-container">
                Show Event Gallery?
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setEventData({
                      ...eventData,
                      allowGallery: e.target.checked,
                    });
                  }}
                  id="allowGallery"
                  name="allowGallery"
                  checked={eventData?.allowGallery || false}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            {eventData?.allowGallery && (
              <div className={formGroupCls}>
                <label>Gallery Passcode</label>
                <input
                  type="text"
                  id="galleryPasscode"
                  name="galleryPasscode"
                  value={eventData?.galleryPasscode || ""}
                  onChange={handleChange}
                  className={inputCls}
                />
              </div>
            )}
            <div className={formGroupCls}>
              <label className="checkbox-container">
                Show Terms and Conditions Page for event.
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setEventData({
                      ...eventData,
                      allowTerms: e.target.checked,
                    });
                  }}
                  id="allowTerms"
                  name="allowTerms"
                  checked={eventData?.allowTerms || false}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            <div className={eventData?.allowTerms ? formGroupCls : "hidden"}>
              <label className="checkbox-container">
                Show Terms inline at the end of the Event page.
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setEventData({
                      ...eventData,
                      showTermsInlineLanding: e.target.checked,
                      ...(e.target.checked ? { showTermsInline: false } : {}),
                    });
                  }}
                  id="showTermsInlineLanding"
                  name="showTermsInlineLanding"
                  checked={eventData?.showTermsInlineLanding || false}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            <div className={eventData?.allowTerms ? formGroupCls : "hidden"}>
              <label className="checkbox-container">
                Show Terms inline at the end of the Register page.
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setEventData({
                      ...eventData,
                      showTermsInline: e.target.checked,
                      ...(e.target.checked
                        ? { showTermsInlineLanding: false }
                        : {}),
                    });
                  }}
                  id="showTermsInline"
                  name="showTermsInline"
                  checked={eventData?.showTermsInline || false}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            <div
              className={
                eventData?.allowPublic || eventData?.allowReg ? "flex flex-wrap gap-4" : "hidden"
              }
            >
              <div className={eventData?.publicUrl ? "flex-none" : "hidden"}>
                {eventData?.allowPublic && (
                  <div>
                    <div className="py-3 bold-font">Event Landing Page</div>
                    <div id="qr-code">
                      <QRCode
                        size={1024}
                        value={getBaseUrl() + eventData?.publicUrl}
                      />
                    </div>
                    <button className={linkBtnCls + " py-0"} onClick={downloadPNG}>
                      Download PNG
                    </button>
                  </div>
                )}
                {eventData?.allowReg && (
                  <div className="">
                    <div className="py-3 bold-font">
                      Event Registration Page
                    </div>
                    <div id="qr-code-reg">
                      <QRCode
                        size={1024}
                        value={
                          getBaseUrl() + "register/" + eventData?.publicUrl
                        }
                      />
                    </div>
                    <button
                      className={linkBtnCls + " py-0"}
                      onClick={downloadRegPNG}
                    >
                      Download PNG
                    </button>
                  </div>
                )}
                {eventData?.allowGallery && (
                  <div className="">
                    <div className="py-3 bold-font">Event Gallery Page</div>
                    <div id="qr-code-gallery">
                      <QRCode
                        size={1024}
                        value={getBaseUrl() + eventData?.publicUrl + "/gallery"}
                      />
                    </div>
                    <button
                      className={linkBtnCls + " py-0"}
                      onClick={downloadGalleryPNG}
                    >
                      Download PNG
                    </button>
                  </div>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <div className={formGroupCls}>
                  <label
                    className={labelCls + " form-help"}
                    onClick={() => {
                      setHelp({ ...help, publicUrl: !help.publicUrl });
                    }}
                  >
                    Public Url{" "}
                    <i className="xs">
                      <InfoIcon />
                    </i>
                  </label>
                  <div className={help.publicUrl ? "fs-xs" : "hidden"}>
                    Url to access the event for self registration. /public-url
                  </div>
                  <input
                    type="text"
                    id="publicUrl"
                    name="publicUrl"
                    value={eventData?.publicUrl || ""}
                    onChange={handleChange}
                    className={inputCls}
                  />
                </div>
                {eventData?.allowGallery && (
                  <div className="pb-3">
                    <a
                      href={getBaseUrl() + eventData?.publicUrl + "/gallery"}
                      target="_blank" rel="noopener noreferrer"
                    >
                      {getBaseUrl() + eventData?.publicUrl + "/gallery"}
                    </a>
                  </div>
                )}
                <div className={formGroupCls}>
                  <label
                    className={labelCls + " form-help"}
                    onClick={() => {
                      setHelp({
                        ...help,
                        seoPrimaryKeyword: !help.seoPrimaryKeyword,
                      });
                    }}
                  >
                    SEO Primary Keyword{" "}
                    <i className="xs">
                      <InfoIcon />
                    </i>
                  </label>
                  <div className={help.seoPrimaryKeyword ? "fs-xs" : "hidden"}>
                    Primary Keyword should also be in the Event Name.
                  </div>
                  <input
                    type="text"
                    id="seoPrimaryKeyword"
                    name="seoPrimaryKeyword"
                    value={eventData?.seoPrimaryKeyword || ""}
                    onChange={handleChange}
                    className={inputCls}
                  />
                </div>
                <div className={formGroupCls}>
                  <label
                    className={labelCls + " form-help"}
                    onClick={() => {
                      setHelp({
                        ...help,
                        seoKeywords: !help.seoKeywords,
                      });
                    }}
                  >
                    SEO Keywords{" "}
                    <i className="xs">
                      <InfoIcon />
                    </i>
                  </label>
                  <div className={help.seoKeywords ? "fs-xs" : "hidden"}>
                    Keywords for the page.
                  </div>
                  <input
                    type="text"
                    id="seoKeywords"
                    name="seoKeywords"
                    value={eventData?.seoKeywords || ""}
                    onChange={handleChange}
                    className={inputCls}
                  />
                </div>
                <div className={formGroupCls}>
                  <label
                    className={labelCls + " form-help"}
                    onClick={() => {
                      setHelp({
                        ...help,
                        seoDescription: !help.seoDescription,
                      });
                    }}
                  >
                    SEO Description{" "}
                    {eventData?.seoDescription
                      ? eventData?.seoDescription.length
                      : 0}
                    /150{" "}
                    <i className="xs">
                      <InfoIcon />
                    </i>
                  </label>
                  <div className={help.seoDescription ? "fs-xs" : "hidden"}>
                    SEO Friendly description of the site.
                  </div>
                  <input
                    type="text"
                    maxLength="150"
                    id="seoDescription"
                    name="seoDescription"
                    value={eventData?.seoDescription || ""}
                    onChange={handleChange}
                    className={inputCls}
                  />
                </div>
              </div>
            </div>

            <div className="py-3"></div>
            <h3>Event Landing Page</h3>
            <div className={formGroupCls}>
              <label className={labelCls}>Banner Image (1600x580)</label>
              <div>
                <input
                  id="originalFileName"
                  type="file"
                  name="originalFileName"
                  onChange={(e) => handleFileRead(e)}
                />
              </div>
            </div>
            <div className={`${formGroupCls} pt-3`}>
              <label className="checkbox-container">
                Hide banner image overlay?
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setEventData({
                      ...eventData,
                      hideOverlay: e.target.checked,
                    });
                  }}
                  id="hideOverlay"
                  name="hideOverlay"
                  checked={eventData?.hideOverlay || false}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            <div className={`${formGroupCls} pt-3`}>
              <label className="checkbox-container">
                Hide banner Chevron (&gt;) in title?
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setEventData({
                      ...eventData,
                      hideBannerChevron: e.target.checked,
                    });
                  }}
                  id="hideBannerChevron"
                  name="hideBannerChevron"
                  checked={eventData?.hideBannerChevron || false}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            <div className={eventData?.bannerImage ? "banner-image" : "hidden"}>
              <img
                id="bannerImage"
                className="w-full"
                src={eventData?.bannerImage}
                alt={eventData?.name}
              />
              <div>
                <button className={linkBtnCls} onClick={removeBannerImage}>
                  Remove Image
                </button>
              </div>
            </div>
            <div className="py-2"></div>
            <div className={formGroupCls}>
              <label className={labelCls}>
                Mobile Banner Image (800x600)
              </label>
              <div>
                <input
                  id="originalMobileFileName"
                  type="file"
                  name="originalMobileFileName"
                  onChange={(e) => handleMobileFileRead(e)}
                />
              </div>
            </div>
            <div
              className={
                eventData?.mobileBannerImage
                  ? "banner-image mobile-banner"
                  : "hidden"
              }
            >
              <img
                className=""
                id="mobileBannerImage"
                src={eventData?.mobileBannerImage}
                alt={eventData?.name}
              />
              <div>
                <button
                  className={linkBtnCls}
                  onClick={removeMobileBannerImage}
                >
                  Remove Image
                </button>
              </div>
            </div>
            <div className={formGroupCls}>
              <label
                className={labelCls + " form-help"}
                onClick={() => {
                  setHelp({ ...help, bannerName: !help.bannerName });
                }}
              >
                Banner Image Name{" "}
                <i className="xs">
                  <InfoIcon />
                </i>
              </label>
              <div className={help.bannerName ? "fs-xs" : "hidden"}>
                Name for the Banner Image.
              </div>
              <input
                type="text"
                id="bannerName"
                name="bannerName"
                value={eventData?.bannerName || ""}
                onChange={handleChange}
                className={inputCls}
              />
            </div>
            <div className={formGroupCls}>
              <label
                className={labelCls + " form-help"}
                onClick={() => {
                  setHelp({ ...help, bannerSubtitle: !help.bannerSubtitle });
                }}
              >
                Banner Image Subtitle{" "}
                <i className="xs">
                  <InfoIcon />
                </i>
              </label>
              <div className={help.bannerSubtitle ? "fs-xs" : "hidden"}>
                Subtitle for the Banner Image.
              </div>
              <input
                type="text"
                id="bannerSubtitle"
                name="bannerSubtitle"
                value={eventData?.bannerSubtitle || ""}
                onChange={handleChange}
                className={inputCls}
              />
            </div>
            <div className={formGroupCls}>
              <label className={labelCls}>Logo Image (512x512)</label>
              <div>
                <input
                  id="originalFileName"
                  type="file"
                  name="originalFileName"
                  onChange={(e) => handleLogoFileRead(e)}
                />
              </div>
            </div>
            <div
              className={
                eventData?.logoImage ? "banner-image  mobile-banner" : "hidden"
              }
            >
              <img
                id="logoImage"
                className=""
                src={eventData?.logoImage}
                alt={eventData?.name}
              />
              <div>
                <button className={linkBtnCls} onClick={removeLogoImage}>
                  Remove Image
                </button>
              </div>
            </div>
            <div className={formGroupCls}>
              <label
                className={labelCls + " form-help"}
                onClick={() => {
                  setHelp({ ...help, dates: !help.dates });
                }}
              >
                Event Dates{" "}
                <i className="xs">
                  <InfoIcon />
                </i>
              </label>
              <div className={help.dates ? "fs-xs" : "hidden"}>
                Description of when the event will happen.
              </div>
              <input
                type="text"
                id="dates"
                name="dates"
                value={eventData?.dates || ""}
                onChange={handleChange}
                className={inputCls}
              />
            </div>
            <div className={formGroupCls}>
              <label
                className={labelCls + " form-help"}
                onClick={() => {
                  setHelp({ ...help, dates2: !help.dates2 });
                }}
              >
                Event Dates #2{" "}
                <i className="xs">
                  <InfoIcon />
                </i>
              </label>
              <div className={help.dates2 ? "fs-xs" : "hidden"}>
                Description #2 of when the event will happen.
              </div>
              <input
                type="text"
                id="dates2"
                name="dates2"
                value={eventData?.dates2 || ""}
                onChange={handleChange}
                className={inputCls}
              />
            </div>
            <div className={formGroupCls}>
              <label
                className={labelCls + " form-help"}
                onClick={() => {
                  setHelp({ ...help, access: !help.access });
                }}
              >
                Event Access{" "}
                <i className="xs">
                  <InfoIcon />
                </i>
              </label>
              <div className={help.access ? "fs-xs" : "hidden"}>
                Description of access level to event.
              </div>
              <input
                type="text"
                id="access"
                name="access"
                value={eventData?.access || ""}
                onChange={handleChange}
                className={inputCls}
              />
            </div>
            <div className={formGroupCls}>
              <label
                className={labelCls + " form-help"}
                onClick={() => {
                  setHelp({ ...help, bgColor: !help.bgColor });
                }}
              >
                Background Color{" "}
                <i className="xs">
                  <InfoIcon />
                </i>
              </label>
              <div className={help.bgColor ? "fs-xs" : "hidden"}>
                Background color to replce standard color on the page.
              </div>
              <input
                type="text"
                id="bgColor"
                name="bgColor"
                value={eventData?.bgColor || ""}
                onChange={handleChange}
                className={inputCls}
              />
            </div>
            <div className={formGroupCls}>
              <label
                className={labelCls + " form-help"}
                onClick={() => {
                  setHelp({ ...help, textColor: !help.textColor });
                }}
              >
                Text Color{" "}
                <i className="xs">
                  <InfoIcon />
                </i>
              </label>
              <div className={help.textColor ? "fs-xs" : "hidden"}>
                Text color to replce text color on the page.
              </div>
              <input
                type="text"
                id="textColor"
                name="textColor"
                value={eventData?.textColor || ""}
                onChange={handleChange}
                className={inputCls}
              />
            </div>
            <div className={formGroupCls}>
              <label
                className={labelCls + " form-help"}
                onClick={() => {
                  setHelp({ ...help, buttonColor: !help.buttonColor });
                }}
              >
                Button Color{" "}
                <i className="xs">
                  <InfoIcon />
                </i>
              </label>
              <div className={help.buttonColor ? "fs-xs" : "hidden"}>
                Button color to replce standard color on the page.
              </div>
              <input
                type="text"
                id="buttonColor"
                name="buttonColor"
                value={eventData?.buttonColor || ""}
                onChange={handleChange}
                className={inputCls}
              />
            </div>
            <div className={formGroupCls}>
              <label
                className={labelCls + " form-help"}
                onClick={() => {
                  setHelp({ ...help, buttonTextColor: !help.buttonTextColor });
                }}
              >
                Button Text Color{" "}
                <i className="xs">
                  <InfoIcon />
                </i>
              </label>
              <div className={help.buttonTextColor ? "fs-xs" : "hidden"}>
                Button text color to replce standard color on the page.
              </div>
              <input
                type="text"
                id="buttonTextColor"
                name="buttonTextColor"
                value={eventData?.buttonTextColor || ""}
                onChange={handleChange}
                className={inputCls}
              />
            </div>
            <div className={formGroupCls}>
              <label className="checkbox-container">
                Hide Header
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setEventData({
                      ...eventData,
                      hideHeader: e.target.checked,
                    });
                  }}
                  id="hideHeader"
                  name="hideHeader"
                  checked={eventData?.hideHeader || false}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            <div className={formGroupCls}>
              <label className="checkbox-container">
                Hide Footer
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setEventData({
                      ...eventData,
                      hideFooter: e.target.checked,
                    });
                  }}
                  id="hideFooter"
                  name="hideFooter"
                  checked={eventData?.hideFooter || false}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            <div className={formGroupCls}>
              <label className="checkbox-container">
                Allow Framer Embed
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setEventData({
                      ...eventData,
                      allowFramerEmbed: e.target.checked,
                    });
                  }}
                  id="allowFramerEmbed"
                  name="allowFramerEmbed"
                  checked={eventData?.allowFramerEmbed || false}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            {eventData?.allowFramerEmbed && (
              <div className={formGroupCls}>
                <label className={labelCls}>Allowed Embed Domains</label>
                <div className="fs-xs">
                  Framer domains are included automatically. Add custom domains
                  one per line, such as https://events.example.com.
                </div>
                <textarea
                  id="framerEmbedDomains"
                  name="framerEmbedDomains"
                  rows="4"
                  value={eventData?.framerEmbedDomains || ""}
                  onChange={handleChange}
                  className={inputCls}
                ></textarea>
              </div>
            )}
            <div className="py-3">
              <hr />
            </div>
            <div className={formGroupCls}>
              <h2>Overview Copy</h2>
              <div className="copy-container">
                <div
                  className={
                    eventData?.overviewCopy ? "mb-3 p-2 edit-copy" : "hidden"
                  }
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(eventData?.overviewCopy),
                  }}
                ></div>
                <button
                  className={secondaryBtnCls}
                  onClick={() => {
                    setEditCopy("overviewCopy");
                  }}
                >
                  Edit Overview Copy
                </button>
                {!eventData?.disableRegistration && (
                  <div className={`${formGroupCls} pt-3`}>
                    <label className="checkbox-container">
                      Show overview copy on register page
                      <input
                        type="checkbox"
                        onChange={(e) => {
                          setEventData({
                            ...eventData,
                            showOverviewReg: e.target.checked,
                          });
                        }}
                        id="showOverviewReg"
                        name="showOverviewReg"
                        checked={eventData?.showOverviewReg || false}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                )}
              </div>
            </div>
            <div className={formGroupCls}>
              <h2>Register Overview Copy</h2>
              <div className="copy-container">
                <div
                  className={
                    eventData?.registerOverviewCopy
                      ? "mb-3 p-2 edit-copy"
                      : "hidden"
                  }
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(eventData?.registerOverviewCopy),
                  }}
                ></div>
                <button
                  className={secondaryBtnCls}
                  onClick={() => {
                    setEditCopy("registerOverviewCopy");
                  }}
                >
                  Edit Register Overview Copy
                </button>
              </div>
            </div>
            {/* <div className="py-3"><hr /></div>
              <h2>Locations</h2>
              <div className={formGroupCls}>
                <label className="checkbox-container">
                  Show Locations?
                  <input
                    type="checkbox"
                    onChange={(e) => {
                      setEventData({
                        ...eventData,
                        showLocations: e.target.checked,
                      });
                    }}
                    id="showLocations"
                    name="showLocations"
                    checked={eventData?.showLocations || false}
                  />
                  <span className="checkmark"></span>
                </label>
              </div>
              {eventData?.showLocations &&
                <>
                  <div className="rounded-md bg-red-50 px-4 py-3 text-sm text-red-700 ring-1 ring-red-200 dark:bg-red-900/30 dark:text-red-200 dark:ring-red-800">Coming Soon</div>
                  <div className="text-right">
                    <button
                      className={primaryBtnCls}
                      onClick={() => {
                        setEventData({
                          ...eventData,
                          locationList: [...eventData?.locationList, {}],
                        });
                      }}
                    >
                      + LOCATION
                    </button>
                  </div>
                  <div className="py-3"></div>
                  {eventData?.locationList?.map((cta, index) => (
                    <div key={index} className={index % 2 === 0 ? "alt-row cta-list-item" : "cta-list-item"}>
                      <div className={formGroupCls}>
                        <label
                          className={labelCls + " form-help"}
                          onClick={() => {
                            setHelp({ ...help, locationTitle: !help.locationTitle });
                          }}
                        >
                          Location #{index + 1} Title{" "}
                          <i className="xs">
                            <InfoIcon />
                          </i>
                        </label>
                        <div className={help.name ? "fs-xs" : "hidden"}>
                          Title for Location #{index + 1}.
                        </div>
                        <input
                          type="text"
                          id={"locationTitle" + index}
                          name="locationTitle"
                          value={eventData?.locationList[index].locationTitle || ''}
                          onChange={(e) => { handleListChange(e, index, 'locationList') }}
                          className={inputCls}
                        />
                      </div>
                      <div className={formGroupCls}>
                        <label
                          className={labelCls + " form-help"}
                          onClick={() => {
                            setHelp({ ...help, locationDescription: !help.locationDescription });
                          }}
                        >
                          Location Description #{index + 1} {" "}
                          <i className="xs">
                            <InfoIcon />
                          </i>
                        </label>
                        <div className={help.name ? "fs-xs" : "hidden"}>
                          Description for Location #{index + 1}.
                        </div>
                        <input
                          type="text"
                          id={"locationDescription" + index}
                          name="locationDescription"
                          value={eventData?.locationList[index].locationDescription || ''}
                          onChange={(e) => { handleListChange(e, index, 'locationList') }}
                          className={inputCls}
                        />
                      </div>
                      <div className="text-right">
                        <i className="del-icon ml-2" onClick={(e) => {
                          removeCloudinary("pcna/ezentrum/" + eventData?.id + "/" + eventData?.id + "_locationList_" + index, null);
                          let locationList = eventData?.locationList;
                          locationList.splice(index, 1);
                          setEventData({ ...eventData, locationList: locationList });
                        }}>
                          <DeleteIcon />
                        </i>
                      </div>
                    </div>
                  ))}
                </>
              } */}
            {/* <div className="py-3"><hr /></div> */}
            {/* <h2>Vehicles</h2>
              <div className={formGroupCls}>
                <label className="checkbox-container">
                  Show Vehicles?
                  <input
                    type="checkbox"
                    onChange={(e) => {
                      setEventData({
                        ...eventData,
                        showVehicles: e.target.checked,
                      });
                    }}
                    id="showVehicles"
                    name="showVehicles"
                    checked={eventData?.showVehicles || false}
                  />
                  <span className="checkmark"></span>
                </label>
              </div>
              {eventData?.showVehicles &&
                <>
                  <div className="rounded-md bg-red-50 px-4 py-3 text-sm text-red-700 ring-1 ring-red-200 dark:bg-red-900/30 dark:text-red-200 dark:ring-red-800">Coming Soon</div>
                  <div className="text-right">
                    <button
                      className={primaryBtnCls}
                      onClick={() => {
                        setEventData({
                          ...eventData,
                          vehicleList: [...eventData?.vehicleList, {}],
                        });
                      }}
                    >
                      + VEHICLE
                    </button>
                  </div>
                  <div className="py-3"></div>
                  {eventData?.vehicleList?.map((cta, index) => (
                    <div key={index} className={index % 2 === 0 ? "alt-row cta-list-item" : "cta-list-item"}>
                      <div className={formGroupCls}>
                        <label
                          className={labelCls + " form-help"}
                          onClick={() => {
                            setHelp({ ...help, vehicleTitle: !help.vehicleTitle });
                          }}
                        >
                          Vehicle #{index + 1} Title{" "}
                          <i className="xs">
                            <InfoIcon />
                          </i>
                        </label>
                        <div className={help.name ? "fs-xs" : "hidden"}>
                          Title for Vehicle #{index + 1}.
                        </div>
                        <input
                          type="text"
                          id={"vehicleTitle" + index}
                          name="vehicleTitle"
                          value={eventData?.vehicleList[index].vehicleTitle || ''}
                          onChange={(e) => { handleListChange(e, index, 'vehicleList') }}
                          className={inputCls}
                        />
                      </div>
                      <div className={formGroupCls}>
                        <label
                          className={labelCls + " form-help"}
                          onClick={() => {
                            setHelp({ ...help, vehicleDescription: !help.vehicleDescription });
                          }}
                        >
                          Vehicle Description #{index + 1}{" "}
                          <i className="xs">
                            <InfoIcon />
                          </i>
                        </label>
                        <div className={help.name ? "fs-xs" : "hidden"}>
                          Description for Vehicle #{index + 1}.
                        </div>
                        <input
                          type="text"
                          id={"vehicleDescription" + index}
                          name="vehicleDescription"
                          value={eventData?.vehicleList[index].vehicleDescription || ''}
                          onChange={(e) => { handleListChange(e, index, 'vehicleList') }}
                          className={inputCls}
                        />
                      </div>
                      <div className="text-right">
                        <i className="del-icon ml-2" onClick={(e) => {
                          removeCloudinary("pcna/ezentrum/" + eventData?.id + "/" + eventData?.id + "_vehicleList_" + index, null);
                          let vehicleList = eventData?.vehicleList;
                          vehicleList.splice(index, 1);
                          setEventData({ ...eventData, vehicleList: vehicleList });
                        }}>
                          <DeleteIcon />
                        </i>
                      </div>
                    </div>
                  ))}
                </>
              } */}
            <div className="py-3">
              <hr />
            </div>
            <h2>Call To Action</h2>
            <div className={formGroupCls}>
              <label className="checkbox-container">
                Show on Register Page?
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setEventData({
                      ...eventData,
                      showCTARegistration: e.target.checked,
                    });
                  }}
                  id="showCTARegistration"
                  name="showCTARegistration"
                  checked={eventData?.showCTARegistration || false}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            <div className={formGroupCls}>
              <label className={labelCls}>Call To Action Layout</label>
              <select
                className={inputCls}
                id="ctaLayout"
                name="ctaLayout"
                onChange={handleChange}
                value={eventData?.ctaLayout}
              >
                <option value="">Select a CTA Layout</option>
                <option value="NoLayout">No Call To Action</option>
                <option value="OnlyButtons">Only Buttons</option>
                {/* <option value="FullTiles">Full Tiles</option> */}
                <option value="SpacedTiles">Spaced Tiles</option>
                <option value="AlternatingRows">Alternating Rows</option>
                <option value="FullRows">Full Rows</option>
              </select>
              {eventData?.ctaLayout &&
              eventData?.ctaLayout === "AlternatingRows" ? (
                <>
                  <label className={labelCls + " mt-2"}>
                    Alternating Row Image Ratio
                  </label>
                  <select
                    className={inputCls}
                    id="alternatingRowRatio"
                    name="alternatingRowRatio"
                    onChange={handleChange}
                    value={eventData?.alternatingRowRatio}
                  >
                    <option value="">
                      Select an Alternating Row Image Ratio
                    </option>
                    <option value="oneThird">1/3</option>
                    <option value="oneHalf">1/2</option>
                    <option value="twoThirds">2/3</option>
                  </select>
                  <label className="checkbox-container mt-3">
                    Start alternating rows with the image on the right.
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        setEventData({
                          ...eventData,
                          alternatingRowsStartRight: e.target.checked,
                        });
                      }}
                      id="alternatingRowsStartRight"
                      name="alternatingRowsStartRight"
                      checked={eventData?.alternatingRowsStartRight || false}
                    />
                    <span className="checkmark"></span>
                  </label>
                </>
              ) : (
                <div></div>
              )}
              {eventData?.ctaLayout &&
              eventData?.ctaLayout === "SpacedTiles" ? (
                <>
                  <label className={labelCls + " mt-2"}>Tiles Per Row</label>
                  <select
                    className={inputCls}
                    id="tilesPerRow"
                    name="tilesPerRow"
                    onChange={handleChange}
                    value={eventData?.tilesPerRow}
                  >
                    <option value="">Select Tiles Per Row</option>
                    <option value="three">3</option>
                    <option value="four">4</option>
                  </select>
                </>
              ) : (
                <div></div>
              )}
            </div>
            {eventData?.ctaLayout && eventData?.ctaLayout !== "NoLayout" ? (
              <div className="cta-container">
                <div className="flex flex-wrap justify-end gap-2">
                  <button
                    className={`${secondaryBtnCls} min-h-11 disabled:cursor-not-allowed disabled:opacity-50`}
                    disabled={!eventData?.ctaList?.length}
                    onClick={() => setAllCTAsExpanded(true)}
                    type="button"
                  >
                    Expand all
                  </button>
                  <button
                    className={`${secondaryBtnCls} min-h-11 disabled:cursor-not-allowed disabled:opacity-50`}
                    disabled={!eventData?.ctaList?.length}
                    onClick={() => setAllCTAsExpanded(false)}
                    type="button"
                  >
                    Collapse all
                  </button>
                  <button
                    className={primaryBtnCls}
                    onClick={addCTA}
                    type="button"
                  >
                    + CTA
                  </button>
                </div>
                <div className="py-3"></div>
                {eventData?.ctaList?.map((cta, index) => (
                  <EventCTAItem
                    item={cta}
                    key={index}
                    id={index}
                    index={index}
                    isExpanded={ctaExpansion[index] ?? false}
                    moveCard={moveCard}
                    onRemove={removeCTA}
                    onToggleExpanded={() =>
                      setCTAExpanded(index, !(ctaExpansion[index] ?? false))
                    }
                    totalItems={eventData.ctaList.length}
                    eventData={eventData}
                    setEventData={setEventData}
                  />
                ))}
                <div className="py-2"></div>
              </div>
            ) : (
              <div></div>
            )}
            <div className={formGroupCls}>
              <label className="checkbox-container">
                Show Contact Us Button?
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setEventData({
                      ...eventData,
                      showContactUs: e.target.checked,
                    });
                  }}
                  id="showContactUs"
                  name="showContactUs"
                  checked={eventData?.showContactUs || false}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            <div className="py-3">
              <hr />
            </div>
            <h2>Image Carousel w/ Lightbox</h2>
            <div className={formGroupCls}>
              <label className="checkbox-container">
                Show Lightbox Carousel?
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setEventData({
                      ...eventData,
                      showLightbox: e.target.checked,
                    });
                  }}
                  id="showLightbox"
                  name="showLightbox"
                  checked={eventData?.showLightbox || false}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            <div className={formGroupCls}>
              <label className="checkbox-container">
                Show Lightbox Carousel (Registration)?
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setEventData({
                      ...eventData,
                      showLightboxRegistration: e.target.checked,
                    });
                  }}
                  id="showLightboxRegistration"
                  name="showLightboxRegistration"
                  checked={eventData?.showLightboxRegistration || false}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            <div
              className={
                eventData?.showLightboxRegistration ? formGroupCls : "hidden"
              }
            >
              <label className="checkbox-container">
                Show Lightbox Carousel after the registration form?
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setEventData({
                      ...eventData,
                      showLightboxAfterRegistration: e.target.checked,
                    });
                  }}
                  id="showLightboxAfterRegistration"
                  name="showLightboxAfterRegistration"
                  checked={eventData?.showLightboxAfterRegistration || false}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            <div
              className={
                eventData?.showLightbox || eventData?.showLightboxRegistration
                  ? formGroupCls
                  : "hidden"
              }
            >
              <label className="checkbox-container">
                Restrict Lightbox Carousel to the container width?
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setEventData({
                      ...eventData,
                      constrainLightboxWidth: e.target.checked,
                    });
                  }}
                  id="constrainLightboxWidth"
                  name="constrainLightboxWidth"
                  checked={eventData?.constrainLightboxWidth || false}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            {(eventData?.showLightbox ||
              eventData?.showLightboxRegistration) && (
              <>
                <div className="text-right">
                  <button
                    className={primaryBtnCls}
                    onClick={() => {
                      setEventData({
                        ...eventData,
                        galleryImages: [...eventData?.galleryImages, ""],
                      });
                    }}
                  >
                    + Image
                  </button>
                </div>
                <div className="py-2"></div>
                <div className="flex flex-wrap gap-4">
                  {eventData?.galleryImages?.map((img, index) => (
                    <div key={index} className="w-1/2 md:w-1/3 lg:w-1/4">
                      <div className="gallery-image-container">
                        <div className={formGroupCls}>
                          <label className={labelCls}>
                            Gallery Image (1200x?)
                          </label>
                          <div>
                            <input
                              id={"originalFileName" + index}
                              type="file"
                              name="originalFileName"
                              onChange={(e) => handleGalleryImageRead(e, index)}
                            />
                          </div>
                        </div>
                        <div className={img ? "" : "hidden"}>
                          <img alt=""
                            id={"galleryImage" + index}
                            className="gallery-image w-100"
                            src={img}
                          />
                        </div>
                        <div className="text-right">
                          <i
                            className="del-icon ml-2"
                            onClick={(e) => {
                              removeCloudinary(
                                "pcna/ezentrum/" +
                                  eventData?.id +
                                  "/" +
                                  eventData?.id +
                                  "_galleryImage_" +
                                  index,
                                null,
                              );
                              let galleryImages = eventData?.galleryImages;
                              galleryImages.splice(index, 1);
                              setEventData({
                                ...eventData,
                                galleryImages: galleryImages,
                              });
                            }}
                          >
                            <DeleteIcon />
                          </i>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
            <div className="py-3">
              <hr />
            </div>
            <h2>Videos</h2>
            <div className={formGroupCls}>
              <label className="checkbox-container">
                Show Videos?
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setEventData({
                      ...eventData,
                      showVideos: e.target.checked,
                    });
                  }}
                  id="showVideos"
                  name="showVideos"
                  checked={eventData?.showVideos || false}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            {eventData?.showVideos && (
              <>
                <div className="text-right">
                  <button
                    className={primaryBtnCls}
                    onClick={() => {
                      setEventData({
                        ...eventData,
                        videoList: [...eventData?.videoList, {}],
                      });
                    }}
                  >
                    + VIDEO
                  </button>
                </div>
                <div className="py-3"></div>
                {eventData?.videoList?.map((cta, index) => (
                  <div
                    key={index}
                    className={
                      index % 2 === 0 ? "alt-row cta-list-item" : "cta-list-item"
                    }
                  >
                    <div className={formGroupCls}>
                      <label
                        className={labelCls + " form-help"}
                        onClick={() => {
                          setHelp({
                            ...help,
                            featuredVideoTitle: !help.featuredVideoTitle,
                          });
                        }}
                      >
                        Video #{index + 1} Title{" "}
                        <i className="xs">
                          <InfoIcon />
                        </i>
                      </label>
                      <div
                        className={help.featuredVideoTitle ? "fs-xs" : "hidden"}
                      >
                        Vimeo link for featured or sizzle reel video #
                        {index + 1}.
                      </div>
                      <input
                        type="text"
                        id={"featuredVideoTitle" + index}
                        name="featuredVideoTitle"
                        value={
                          eventData?.videoList[index].featuredVideoTitle || ""
                        }
                        onChange={(e) => {
                          handleListChange(e, index, "videoList");
                        }}
                        className={inputCls}
                      />
                    </div>
                    <div className={formGroupCls}>
                      <label
                        className={labelCls + " form-help"}
                        onClick={() => {
                          setHelp({
                            ...help,
                            featuredVideo: !help.featuredVideo,
                          });
                        }}
                      >
                        Featured Video #{index + 1}{" "}
                        <i className="xs">
                          <InfoIcon />
                        </i>
                      </label>
                      <div className={help.featuredVideo ? "fs-xs" : "hidden"}>
                        Vimeo link for featured or sizzle reel video #
                        {index + 1}.
                      </div>
                      <input
                        type="text"
                        id={"featuredVideo" + index}
                        name="featuredVideo"
                        value={eventData?.videoList[index].featuredVideo || ""}
                        onChange={(e) => {
                          handleListChange(e, index, "videoList");
                        }}
                        className={inputCls}
                      />
                    </div>
                    <div className="text-right">
                      <i
                        className="del-icon ml-2"
                        onClick={(e) => {
                          let videoList = eventData?.videoList;
                          videoList.splice(index, 1);
                          setEventData({ ...eventData, videoList: videoList });
                        }}
                      >
                        <DeleteIcon />
                      </i>
                    </div>
                  </div>
                ))}
              </>
            )}
            <div className="py-3">
              <hr />
            </div>
            <h2>Story Stream</h2>
            <div className={formGroupCls}>
              <label
                className={labelCls + " form-help"}
                onClick={() => {
                  setHelp({
                    ...help,
                    storyStreamTitle: !help.storyStreamTitle,
                  });
                }}
              >
                Story Stream Title{" "}
                <i className="xs">
                  <InfoIcon />
                </i>
              </label>
              <div className={help.storyStreamTitle ? "fs-xs" : "hidden"}>
                Title of the story stream.
              </div>
              <input
                type="text"
                id="storyStreamTitle"
                name="storyStreamTitle"
                value={eventData?.storyStreamTitle || ""}
                onChange={handleChange}
                className={inputCls}
              />
            </div>
            <div className={formGroupCls}>
              <label
                className={labelCls + " form-help"}
                onClick={() => {
                  setHelp({
                    ...help,
                    storyStreamSubtitle: !help.storyStreamSubtitle,
                  });
                }}
              >
                Story Stream Subtitle{" "}
                <i className="xs">
                  <InfoIcon />
                </i>
              </label>
              <div className={help.storyStreamSubtitle ? "fs-xs" : "hidden"}>
                Typically the hashtag for the program.
              </div>
              <input
                type="text"
                id="storyStreamSubtitle"
                name="storyStreamSubtitle"
                value={eventData?.storyStreamSubtitle || ""}
                onChange={handleChange}
                className={inputCls}
              />
            </div>
            <div className={formGroupCls}>
              <label
                className={labelCls + " form-help"}
                onClick={() => {
                  setHelp({ ...help, storyStream: !help.storyStream });
                }}
              >
                Story Stream{" "}
                <i className="xs">
                  <InfoIcon />
                </i>
              </label>
              <div className={help.storyStream ? "fs-xs" : "hidden"}>
                Link to embed story stream into landing page for the event.
              </div>
              <input
                type="text"
                id="storyStream"
                name="storyStream"
                value={eventData?.storyStream || ""}
                onChange={handleChange}
                className={inputCls}
              />
            </div>
            <div
              className={
                !eventData?.disableRegistration ? formGroupCls : "hidden"
              }
            >
              <label>Pending Confirmation Copy</label>
              <div className="copy-container">
                <div
                  className={
                    eventData?.pendingConfirmationCopy
                      ? "mb-3 p-2 edit-copy"
                      : "hidden"
                  }
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(
                      eventData?.pendingConfirmationCopy,
                    ),
                  }}
                ></div>
                <button
                  className={secondaryBtnCls}
                  onClick={() => {
                    setEditCopy("pendingConfirmationCopy");
                  }}
                >
                  Edit Pending Confirmation Copy
                </button>
              </div>
            </div>
            <div
              className={
                !eventData?.disableRegistration ? formGroupCls : "hidden"
              }
            >
              <label>Confirmation Copy</label>
              <div className="copy-container">
                <div
                  className={
                    eventData?.confirmationCopy
                      ? "mb-3 p-2 edit-copy"
                      : "hidden"
                  }
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(eventData?.confirmationCopy),
                  }}
                ></div>
                <button
                  className={secondaryBtnCls}
                  onClick={() => {
                    setEditCopy("confirmationCopy");
                  }}
                >
                  Edit Confirmation Copy
                </button>
              </div>
            </div>
            <div className={formGroupCls}>
              <label className="checkbox-container">
                Disable automatic Reference Code display
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setEventData({
                      ...eventData,
                      disableAutoReferenceCode: e.target.checked,
                    });
                  }}
                  id="disableAutoReferenceCode"
                  name="disableAutoReferenceCode"
                  checked={eventData?.disableAutoReferenceCode || false}
                />
                <span className="checkmark"></span>
              </label>
              <div className="fs-xs">
                If confirmation page or email/SMS copy does not include {"{id}"},
                the registration ID is added at the bottom as Reference Code.
                Check this to hide that fallback.
              </div>
            </div>
            <div className={formGroupCls}>
              <label className="checkbox-container">
                Show registration details on Confirmation Page
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setEventData({
                      ...eventData,
                      showRegDetails: e.target.checked,
                    });
                  }}
                  id="showRegDetails"
                  name="showRegDetails"
                  checked={eventData?.showRegDetails || false}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            <div
              className={
                !eventData?.disableRegistration && eventData?.allowWaitlist
                  ? formGroupCls
                  : "hidden"
              }
            >
              <label>Waitlist Copy</label>
              <div className="copy-container">
                <div
                  className={
                    eventData?.waitlistCopy ? "mb-3 p-2 edit-copy" : "hidden"
                  }
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(eventData?.waitlistCopy),
                  }}
                ></div>
                <button
                  className={secondaryBtnCls}
                  onClick={() => {
                    setEditCopy("waitlistCopy");
                  }}
                >
                  Edit Waitlist Copy
                </button>
              </div>
            </div>
            {eventData?.allowFAQ && (
              <div className={formGroupCls}>
                <h2>FAQ</h2>
                <div className={formGroupCls}>
                  <label className={labelCls} htmlFor="faqTitle">
                    FAQ Title
                  </label>
                  <input
                    id="faqTitle"
                    type="text"
                    name="faqTitle"
                    value={eventData?.faqTitle || ""}
                    placeholder={`${eventData?.name || "Event"} FAQ`}
                    className={inputCls}
                    onChange={(e) => {
                      setEventData({
                        ...eventData,
                        faqTitle: e.target.value,
                      });
                    }}
                  />
                  <p className="mt-1 text-sm text-zinc-500 dark:text-zinc-400">
                    Leave blank to use {eventData?.name || "Event"} FAQ.
                  </p>
                </div>
                <label>FAQ Copy</label>
                <div className="copy-container">
                  <div
                    className={
                      eventData?.faqCopy ? "mb-3 p-2 edit-copy" : "hidden"
                    }
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(eventData?.faqCopy),
                    }}
                  ></div>
                  <button
                    className={secondaryBtnCls}
                    onClick={() => {
                      setEditCopy("faqCopy");
                    }}
                  >
                    Edit FAQ Copy
                  </button>
                </div>
                <div className="text-right">
                  <button
                    className={primaryBtnCls}
                    onClick={() => {
                      let tmpFaqCategories = eventData?.faqCategories
                        ? eventData?.faqCategories
                        : [];
                      tmpFaqCategories.push({ catName: "", faqs: [] });
                      setEventData({
                        ...eventData,
                        faqCategories: tmpFaqCategories,
                      });
                    }}
                  >
                    + FAQ Category
                  </button>
                </div>
                <div className="py-2"></div>
                <div className="flex flex-wrap gap-4">
                  {eventData?.faqCategories?.map((c, index) => (
                    <div
                      key={index}
                      className={index % 2 === 0 ? "alt-row w-full" : "w-full"}
                    >
                      <div className="faq-category">
                        <div className={formGroupCls}>
                          <label className={labelCls}>Category Name</label>
                          <div>
                            <input
                              id={"catName-" + index}
                              type="text"
                              name="catName"
                              value={c.catName}
                              className={inputCls}
                              onChange={(e) => {
                                let tmpFaqCategories = eventData?.faqCategories;
                                tmpFaqCategories[index].catName =
                                  e.target.value;
                                setEventData({
                                  ...eventData,
                                  faqCategories: tmpFaqCategories,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <hr />
                        <div className="text-right">
                          <button
                            className={primaryBtnCls}
                            onClick={() => {
                              let tmpFaqs = c.faqs ? c.faqs : [];
                              tmpFaqs.push({
                                question: "",
                                answer: "",
                                qFullRow: c.catFullRow ? false : true,
                              });
                              let tmpFaqCategories = eventData?.faqCategories;
                              tmpFaqCategories[index].faqs = tmpFaqs;
                              setEventData({
                                ...eventData,
                                faqCategories: tmpFaqCategories,
                              });
                            }}
                          >
                            + FAQ Question
                          </button>
                        </div>
                        {c?.faqs?.map((q, i) => (
                          <div
                            key={i}
                            className={i % 2 === 0 ? "alt-row w-full" : "w-full"}
                          >
                            <div className="faq-question">
                              <div className={formGroupCls}>
                                <label className={labelCls}>Question</label>
                                <div>
                                  <input
                                    id={"catName-" + index + "-question-" + i}
                                    type="text"
                                    name="faqQuestion"
                                    value={q.question}
                                    className={inputCls}
                                    onChange={(e) => {
                                      let tmpFaqCategories =
                                        eventData?.faqCategories;
                                      tmpFaqCategories[index].faqs[i].question =
                                        e.target.value;
                                      setEventData({
                                        ...eventData,
                                        faqCategories: tmpFaqCategories,
                                      });
                                    }}
                                  />
                                </div>
                              </div>
                              <div className={formGroupCls}>
                                <label className={labelCls}>Answer</label>
                                <div>
                                  <textarea
                                    rows="10"
                                    className={inputCls}
                                    value={q.answer}
                                    onChange={(e) => {
                                      let tmpFaqCategories =
                                        eventData?.faqCategories;
                                      tmpFaqCategories[index].faqs[i].answer =
                                        e.target.value;
                                      setEventData({
                                        ...eventData,
                                        faqCategories: tmpFaqCategories,
                                      });
                                    }}
                                  ></textarea>
                                </div>
                              </div>
                              <div className={formGroupCls}>
                                <label className="checkbox-container">
                                  Question Full Row
                                  <input
                                    type="checkbox"
                                    onChange={(e) => {
                                      let tmpFaqCategories =
                                        eventData?.faqCategories;
                                      tmpFaqCategories[index].faqs[i].qFullRow =
                                        e.target.checked;
                                      setEventData({
                                        ...eventData,
                                        faqCategories: tmpFaqCategories,
                                      });
                                    }}
                                    id={"qFullRow" + i}
                                    name="qFullRow"
                                    checked={q?.qFullRow || false}
                                  />
                                  <span className="checkmark"></span>
                                </label>
                              </div>
                              <div className="text-right">
                                <i
                                  className="del-icon ml-2"
                                  onClick={(e) => {
                                    let tmpFaqCategories =
                                      eventData?.faqCategories;
                                    tmpFaqCategories[index].faqs.splice(i, 1);
                                    setEventData({
                                      ...eventData,
                                      faqCategories: tmpFaqCategories,
                                    });
                                  }}
                                >
                                  <DeleteIcon />
                                </i>{" "}
                                FAQ
                              </div>
                            </div>
                          </div>
                        ))}
                        <div className="py-3">
                          <hr />
                        </div>
                        <div className="text-right">
                          <i
                            className="del-icon ml-2"
                            onClick={(e) => {
                              let tmpFaqCategories = eventData?.faqCategories;
                              tmpFaqCategories.splice(index, 1);
                              setEventData({
                                ...eventData,
                                faqCategories: tmpFaqCategories,
                              });
                            }}
                          >
                            <DeleteIcon />
                          </i>{" "}
                          FAQ Category
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {eventData?.allowGallery && !eventData?.disableRegistration && (
              <div className={formGroupCls}>
                <label>Gallery Copy</label>
                <div className="copy-container">
                  <div
                    className={
                      eventData?.galleryCopy ? "mb-3 p-2 edit-copy" : "hidden"
                    }
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(eventData?.galleryCopy),
                    }}
                  ></div>
                  <button
                    className={secondaryBtnCls}
                    onClick={() => {
                      setEditCopy("galleryCopy");
                    }}
                  >
                    Edit Gallery Copy
                  </button>
                </div>
              </div>
            )}
            {eventData?.allowTerms && !eventData?.disableRegistration && (
              <>
                <div className={formGroupCls}>
                  <label
                    className={labelCls + " form-help"}
                    onClick={() => {
                      setHelp({ ...help, termsTitle: !help.termsTitle });
                    }}
                  >
                    Terms Title Override{" "}
                    <i className="xs">
                      <InfoIcon />
                    </i>
                  </label>
                  <div className={help.termsTitle ? "fs-xs" : "hidden"}>
                    Override title of the terms and conditions page.
                  </div>
                  <input
                    type="text"
                    id="termsTitle"
                    name="termsTitle"
                    value={eventData?.termsTitle || ""}
                    onChange={handleChange}
                    className={inputCls}
                  />
                </div>
                <div className={formGroupCls}>
                  <label>Terms & Conditions Copy</label>
                  <div className="copy-container">
                    <div
                      className={
                        eventData?.termsCopy ? "mb-3 p-2 edit-copy" : "hidden"
                      }
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(eventData?.termsCopy),
                      }}
                    ></div>
                    <button
                      className={secondaryBtnCls}
                      onClick={() => {
                        setEditCopy("termsCopy");
                      }}
                    >
                      Edit Terms Copy
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        )}
      </div>
      <div className={cardCls}>
        <div
          className={cardHeaderCls}
          onClick={() => {
            updateShowModules("notifications", !showModules.notifications);
          }}
        >
          <h2>Event Notifications</h2>
          <div>
            <span
              className={showModules.notifications ? "pe-3 text-xs font-bold" : "pe-3 text-xs"}
            >
              Show
            </span>
            <span className={!showModules.notifications ? "text-xs font-bold" : "text-xs"}>
              Hide
            </span>
          </div>
        </div>
        {showModules.notifications && (
          <div className={cardBodyCls}>
            {!eventData?.disableRegistration ? (
              <>
                <div className={formGroupCls}>
                  <label className={labelCls}>Support Email</label>
                  <div className="mb-3 flex">
                    <select
                      className={inputCls}
                      id="email"
                      name="email"
                      onChange={handleChange}
                      value={eventData?.email}
                    >
                      <option value=""></option>
                      {settings.mailboxes.map((mailbox, index) => (
                        <option key={index} value={mailbox}>
                          {mailbox}
                        </option>
                      ))}
                    </select>
                    <span className="ml-2 inline-flex items-center rounded-md bg-zinc-100 px-3 py-2 text-sm text-zinc-700 ring-1 ring-inset ring-zinc-300 dark:bg-zinc-800 dark:text-zinc-300 dark:ring-white/10" id="basic-addon">
                      @porsche-ezentrum.us
                    </span>
                  </div>
                </div>
                <div className={formGroupCls}>
                  <label className={labelCls}>
                    Bcc Admin Emails (comma separated addresses)
                  </label>
                  <input
                    type="text"
                    id="bccEmail"
                    name="bccEmail"
                    value={eventData?.bccEmail || ""}
                    onChange={handleChange}
                    className={inputCls}
                  />
                </div>
                <div className={formGroupCls}>
                  <label className={labelCls}>Email From</label>
                  <input
                    type="text"
                    id="emailFrom"
                    name="emailFrom"
                    value={eventData?.emailFrom || ""}
                    onChange={handleChange}
                    className={inputCls}
                  />
                </div>
                {/* <div className={formGroupCls}>
                <label className={labelCls}>Reply To</label>
                <input
                  type="text"
                  id="replyTo"
                  name="replyTo"
                  value={eventData?.replyTo || ''}
                  onChange={handleChange}
                  className={inputCls}
                />
              </div> */}
                <div className={formGroupCls}>
                  <label className={labelCls}>Email Campaign Code</label>
                  <input
                    type="text"
                    id="emailCampaignCode"
                    name="emailCampaignCode"
                    value={eventData?.emailCampaignCode || ""}
                    onChange={handleChange}
                    className={inputCls}
                  />
                </div>
                <div className={formGroupCls}>
                  <label className={labelCls}>
                    Email Banner Image (1600x580)
                  </label>
                  <div>
                    <input
                      id="originalEmailFileName"
                      type="file"
                      name="originalEmailFileName"
                      onChange={(e) => handleEmailFileRead(e)}
                    />
                  </div>
                </div>
                <div className={eventData?.emailBannerImage ? "" : "hidden"}>
                  <img
                    id="emailBannerImage"
                    className="desktop-image"
                    src={eventData?.emailBannerImage}
                    alt={eventData?.name}
                  />
                  <div>
                    <button
                      className={linkBtnCls}
                      onClick={removeEmailBannerImage}
                    >
                      Remove Image
                    </button>
                  </div>
                </div>
                <div className="py-2"></div>
                <div className={formGroupCls}>
                  <label className={labelCls}>
                    Mobile Email Banner Image (800x600)
                  </label>
                  <div>
                    <input
                      id="originalMobileEmailFileName"
                      type="file"
                      name="originalMobileEmailFileName"
                      onChange={(e) => handleMobileEmailFileRead(e)}
                    />
                  </div>
                </div>
                <div
                  className={
                    eventData?.mobileEmailBannerImage
                      ? "banner-image mobile-banner"
                      : "hidden"
                  }
                >
                  <img
                    className="mobile-image"
                    id="mobileEmailBannerImage"
                    src={eventData?.mobileEmailBannerImage}
                    alt={eventData?.name}
                  />
                  <div>
                    <button
                      className={linkBtnCls}
                      onClick={removeMobileEmailBannerImage}
                    >
                      Remove Image
                    </button>
                  </div>
                </div>
                <div className={formGroupCls}>
                  <label className="checkbox-container">
                    Send confirmation{" "}
                    {eventData?.allowWaitlist ? "/ waitlist" : ""} email.
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        setEventData({
                          ...eventData,
                          allowConfirmationEmail: e.target.checked,
                        });
                      }}
                      id="allowConfirmationEmail"
                      name="allowConfirmationEmail"
                      checked={eventData?.allowConfirmationEmail || false}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                <div className={formGroupCls}>
                  <label className="checkbox-container">
                    Hide Email Logo (only do this if logo is included in email
                    banner image(s).)
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        setEventData({
                          ...eventData,
                          hideLogo: e.target.checked,
                        });
                      }}
                      id="hideLogo"
                      name="hideLogo"
                      checked={eventData?.hideLogo || false}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                <div className={formGroupCls}>
                  <label
                    className={labelCls + " form-help"}
                    onClick={() => {
                      setHelp({
                        ...help,
                        pendingEmailSubject: !help.pendingEmailSubject,
                      });
                    }}
                  >
                    Pending Email Subject{" "}
                    <i className="xs">
                      <InfoIcon />
                    </i>
                  </label>
                  <div
                    className={help.pendingEmailSubject ? "fs-xs" : "hidden"}
                  >
                    Pending Email Subject
                  </div>
                  <input
                    type="text"
                    id="pendingEmailSubject"
                    name="pendingEmailSubject"
                    value={eventData?.pendingEmailSubject || ""}
                    onChange={handleChange}
                    className={inputCls}
                  />
                </div>
                <div className={formGroupCls}>
                  <label>Pending Email Copy</label>
                  <div className="copy-container">
                    <div
                      className={
                        eventData?.pendingEmailCopy
                          ? "mb-3 p-2 edit-copy"
                          : "hidden"
                      }
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(eventData?.pendingEmailCopy),
                      }}
                    ></div>
                    <button
                      className={secondaryBtnCls}
                      onClick={() => {
                        setEditCopy("pendingEmailCopy");
                      }}
                    >
                      Edit Pending Email Copy
                    </button>
                  </div>
                </div>
                <div className={formGroupCls}>
                  <label
                    className={labelCls + " form-help"}
                    onClick={() => {
                      setHelp({
                        ...help,
                        confirmationEmailSubject:
                          !help.confirmationEmailSubject,
                      });
                    }}
                  >
                    Confirmation Email Subject{" "}
                    <i className="xs">
                      <InfoIcon />
                    </i>
                  </label>
                  <div
                    className={
                      help.confirmationEmailSubject ? "fs-xs" : "hidden"
                    }
                  >
                    Confirmation Email Subject
                  </div>
                  <input
                    type="text"
                    id="confirmationEmailSubject"
                    name="confirmationEmailSubject"
                    value={eventData?.confirmationEmailSubject || ""}
                    onChange={handleChange}
                    className={inputCls}
                  />
                </div>
                <div className={formGroupCls}>
                  <label>Confirmation Email Copy</label>
                  <div className="copy-container">
                    <div
                      className={
                        eventData?.confirmationEmailCopy
                          ? "mb-3 p-2 edit-copy"
                          : "hidden"
                      }
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                          eventData?.confirmationEmailCopy,
                        ),
                      }}
                    ></div>
                    <button
                      className={secondaryBtnCls}
                      onClick={() => {
                        setEditCopy("confirmationEmailCopy");
                      }}
                    >
                      Edit Confirmation Email Copy
                    </button>
                  </div>
                </div>
                <div className={formGroupCls}>
                  <label className="checkbox-container">
                    Disable automatic Reference Code display
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        setEventData({
                          ...eventData,
                          disableAutoReferenceCode: e.target.checked,
                        });
                      }}
                      id="disableAutoReferenceCodeEmail"
                      name="disableAutoReferenceCode"
                      checked={eventData?.disableAutoReferenceCode || false}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <div className="fs-xs">
                    If confirmation email or SMS copy does not include {"{id}"},
                    the registration ID is added at the bottom as Reference
                    Code. Check this to hide that fallback.
                  </div>
                </div>
                {eventData?.allowWaitlist ? (
                  <div className={formGroupCls}>
                    <label
                      className={labelCls + " form-help"}
                      onClick={() => {
                        setHelp({
                          ...help,
                          waitlistEmailSubject: !help.waitlistEmailSubject,
                        });
                      }}
                    >
                      Waitlist Email Subject{" "}
                      <i className="xs">
                        <InfoIcon />
                      </i>
                    </label>
                    <div
                      className={help.waitlistEmailSubject ? "fs-xs" : "hidden"}
                    >
                      Waitlist Email Subject
                    </div>
                    <input
                      type="text"
                      id="waitlistEmailSubject"
                      name="waitlistEmailSubject"
                      value={eventData?.waitlistEmailSubject || ""}
                      onChange={handleChange}
                      className={inputCls}
                    />
                  </div>
                ) : (
                  <div></div>
                )}
                <div
                  className={
                    eventData?.allowConfirmationEmail &&
                    eventData?.allowWaitlist
                      ? formGroupCls
                      : "hidden"
                  }
                >
                  <label>Waitlist Email Copy</label>
                  <div className="copy-container">
                    <div
                      className={
                        eventData?.waitlistEmailCopy
                          ? "mb-3 p-2 edit-copy"
                          : "hidden"
                      }
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                          eventData?.waitlistEmailCopy,
                        ),
                      }}
                    ></div>
                    <button
                      className={secondaryBtnCls}
                      onClick={() => {
                        setEditCopy("waitlistEmailCopy");
                      }}
                    >
                      Edit Waitlist Email Copy
                    </button>
                  </div>
                </div>
                <div className={formGroupCls}>
                  <label
                    className={labelCls + " form-help"}
                    onClick={() => {
                      setHelp({
                        ...help,
                        reminderEmailSubject: !help.reminderEmailSubject,
                      });
                    }}
                  >
                    Reminder Email Subject{" "}
                    <i className="xs">
                      <InfoIcon />
                    </i>
                  </label>
                  <div
                    className={help.reminderEmailSubject ? "fs-xs" : "hidden"}
                  >
                    Reminder Email Subject
                  </div>
                  <input
                    type="text"
                    id="reminderEmailSubject"
                    name="reminderEmailSubject"
                    value={eventData?.reminderEmailSubject || ""}
                    onChange={handleChange}
                    className={inputCls}
                  />
                </div>
                <div className={formGroupCls}>
                  <label>Reminder Email Copy</label>
                  <div className="copy-container">
                    <div
                      className={
                        eventData?.reminderEmailCopy
                          ? "mb-3 p-2 edit-copy"
                          : "hidden"
                      }
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                          eventData?.reminderEmailCopy,
                        ),
                      }}
                    ></div>
                    <button
                      className={secondaryBtnCls}
                      onClick={() => {
                        setEditCopy("reminderEmailCopy");
                      }}
                    >
                      Edit Reminder Email Copy
                    </button>
                  </div>
                </div>
                <div className={formGroupCls}>
                  <label
                    className={labelCls + " form-help"}
                    onClick={() => {
                      setHelp({
                        ...help,
                        cancellationEmailSubject:
                          !help.cancellationEmailSubject,
                      });
                    }}
                  >
                    Cancellation Email Subject{" "}
                    <i className="xs">
                      <InfoIcon />
                    </i>
                  </label>
                  <div
                    className={
                      help.cancellationEmailSubject ? "fs-xs" : "hidden"
                    }
                  >
                    Cancellation Email Subject
                  </div>
                  <input
                    type="text"
                    id="cancellationEmailSubject"
                    name="cancellationEmailSubject"
                    value={eventData?.cancellationEmailSubject || ""}
                    onChange={handleChange}
                    className={inputCls}
                  />
                </div>
                <div className={formGroupCls}>
                  <label>Cancellation Email Copy</label>
                  <div className="copy-container">
                    <div
                      className={
                        eventData?.cancellationEmailCopy
                          ? "mb-3 p-2 edit-copy"
                          : "hidden"
                      }
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                          eventData?.cancellationEmailCopy,
                        ),
                      }}
                    ></div>
                    <button
                      className={secondaryBtnCls}
                      onClick={() => {
                        setEditCopy("cancellationEmailCopy");
                      }}
                    >
                      Edit Cancellation Email Copy
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}
          </div>
        )}
      </div>
      <div className={cardCls}>
        <div
          className={cardHeaderCls}
          onClick={() => {
            updateShowModules("configuration", !showModules.configuration);
          }}
        >
          <h2>Registration Configuration</h2>
          <div>
            <span
              className={showModules.configuration ? "pe-3 text-xs font-bold" : "pe-3 text-xs"}
            >
              Show
            </span>
            <span className={!showModules.configuration ? "text-xs font-bold" : "text-xs"}>
              Hide
            </span>
          </div>
        </div>
        {showModules.configuration && (
          <div className={cardBodyCls}>
            <div className={formGroupCls}>
              <label className="checkbox-container">
                External / No Registration Required?
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setEventData({
                      ...eventData,
                      disableRegistration: e.target.checked,
                    });
                  }}
                  id="disableRegistration"
                  name="disableRegistration"
                  checked={eventData?.disableRegistration || false}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            {!eventData?.disableRegistration && (
              <>
                <div className={formGroupCls}>
                  <label className="checkbox-container">
                    Disable Front End Registration
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        setEventData({
                          ...eventData,
                          disableFrontEndRegistration: e.target.checked,
                        });
                      }}
                      id="disableFrontEndRegistration"
                      name="disableFrontEndRegistration"
                      checked={eventData?.disableFrontEndRegistration || false}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                {eventData?.allowWaitlist && (
                  <div className={formGroupCls}>
                    <label className="checkbox-container">
                      Force Event Full / Waitlist Only
                      <input
                        type="checkbox"
                        onChange={(e) => {
                          setEventData({
                            ...eventData,
                            forceEventFull: e.target.checked,
                          });
                        }}
                        id="forceEventFull"
                        name="forceEventFull"
                        checked={eventData?.forceEventFull || false}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                )}
                <div className={formGroupCls}>
                  <label className="checkbox-container">
                    Allow registration lookup / edit?
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        setEventData({
                          ...eventData,
                          allowLookup: e.target.checked,
                        });
                      }}
                      id="allowLookup"
                      name="allowLookup"
                      checked={eventData?.allowLookup || false}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                <div className={formGroupCls}>
                  <label className="checkbox-container">
                    QR Code direct to edit instead of check-in page?
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        setEventData({
                          ...eventData,
                          qrCodeToEdit: e.target.checked,
                        });
                      }}
                      id="qrCodeToEdit"
                      name="qrCodeToEdit"
                      checked={eventData?.qrCodeToEdit || false}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                <div className={formGroupCls}>
                  <label className="checkbox-container">
                    Front-End registrations require unique email.
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        setEventData({
                          ...eventData,
                          allowUniqueEmail: e.target.checked,
                        });
                      }}
                      id="allowUniqueEmail"
                      name="allowUniqueEmail"
                      checked={eventData?.allowUniqueEmail || false}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                {/* <div className={formGroupCls}>
                <label className="checkbox-container">
                  Use Address Validation
                  <input
                    type="checkbox"
                    onChange={(e) => {
                      setEventData({
                        ...eventData,
                        allowAddressValidation: e.target.checked,
                      });
                    }}
                    id="allowAddressValidation"
                    name="allowAddressValidation"
                    checked={eventData?.allowAddressValidation || false}
                  />
                  <span className="checkmark"></span>
                </label>
              </div> */}
                <div className={formGroupCls}>
                  <label className="checkbox-container">
                    Enable event waitlist?
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        setEventData({
                          ...eventData,
                          allowWaitlist: e.target.checked,
                        });
                      }}
                      id="allowWaitlist"
                      name="allowWaitlist"
                      checked={eventData?.allowWaitlist}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                {eventData?.allowWaitlist && (
                  <div className={formGroupCls}>
                    <label className={labelCls} htmlFor="waitlistMessage">
                      Waitlist Message
                    </label>
                    <input
                      type="text"
                      id="waitlistMessage"
                      name="waitlistMessage"
                      placeholder="Unfortunately the event is at capacity, but you can still join the waitlist."
                      value={eventData?.waitlistMessage || ""}
                      onChange={handleChange}
                      className={inputCls}
                    />
                  </div>
                )}
                <CommerceRegistrationOptions
                  eventData={eventData}
                  setEventData={setEventData}
                  formGroupCls={formGroupCls}
                />
                <div className={formGroupCls}>
                  <label className="checkbox-container">
                    Require Waivers during registration.
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        console.log(eventData?.allowWaivers);
                        setEventData({
                          ...eventData,
                          allowWaivers: e.target.checked,
                        });
                      }}
                      id="allowWaivers"
                      name="allowWaivers"
                      checked={eventData?.allowWaivers || false}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                {eventData?.allowGuests && eventData?.allowWaivers && (
                  <div className={formGroupCls}>
                    <label className="checkbox-container">
                      Require Guest Waivers during registration.
                      <input
                        type="checkbox"
                        onChange={(e) => {
                          console.log(eventData?.allowGuestWaivers);
                          setEventData({
                            ...eventData,
                            allowGuestWaivers: e.target.checked,
                          });
                        }}
                        id="allowGuestWaivers"
                        name="allowGuestWaivers"
                        checked={eventData?.allowGuestWaivers || false}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                )}
                <div
                  className={
                    eventData?.allowWaivers && !eventData?.disableRegistration
                      ? formGroupCls
                      : "hidden"
                  }
                >
                  <label className={labelCls}>Waiver</label>
                  <select
                    className={inputCls}
                    id="waiver"
                    name="waiver"
                    onChange={(e) => {
                      setEventData({
                        ...eventData,
                        waiverIndex: e.target.value,
                        waiverCopy:
                          settings.waiverDefaultCopy?.length > 0
                            ? settings.waiverDefaultCopy[e.target.value]
                            : null,
                      });
                    }}
                    value={eventData?.waiverIndex}
                  >
                    <option value=""></option>
                    {settings.waiverDefaultCopy.map((waiver, index) => (
                      <option key={index} value={index}>
                        {waiver.name}
                      </option>
                    ))}
                  </select>
                </div>
                {eventData?.allowWaivers && eventData?.waiverCopy && (
                  <div className="fs-xs pb-3">
                    {!showWaiver && (
                      <span
                        className="underline pointer"
                        onClick={() => {
                          setShowWaiver(true);
                        }}
                      >
                        Show Waiver
                      </span>
                    )}
                    {showWaiver && (
                      <span
                        className="underline pointer"
                        onClick={() => {
                          setShowWaiver(false);
                        }}
                      >
                        Hide Waiver
                      </span>
                    )}
                  </div>
                )}
                <div
                  className={
                    eventData?.allowWaivers &&
                    eventData?.waiverCopy &&
                    showWaiver
                      ? ""
                      : "hidden"
                  }
                >
                  <div
                    className={!eventData?.disableRegistration ? "" : "hidden"}
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(
                        eventData?.waiverCopy?.content,
                      ),
                    }}
                  ></div>
                </div>
                <div className={formGroupCls}>
                  <label className="checkbox-container">
                    Allow Checked-Out Stauts
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        setEventData({
                          ...eventData,
                          allowCheckedOut: e.target.checked,
                        });
                      }}
                      id="allowCheckedOut"
                      name="allowCheckedOut"
                      checked={eventData?.allowCheckedOut || false}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                <div className={formGroupCls}>
                  <label className="checkbox-container">
                    Allow Session Editing?
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        setEventData({
                          ...eventData,
                          allowSessionEditing: e.target.checked,
                        });
                      }}
                      id="allowSessionEditing"
                      name="allowSessionEditing"
                      checked={eventData?.allowSessionEditing || false}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                <div className={formGroupCls}>
                  <label className="checkbox-container">
                    Disable Quick Check-In?
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        setEventData({
                          ...eventData,
                          disableQuickCheckIn: e.target.checked,
                        });
                      }}
                      id="disableQuickCheckIn"
                      name="disableQuickCheckIn"
                      checked={eventData?.disableQuickCheckIn || false}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                <div className={formGroupCls}>
                  <label className="checkbox-container">
                    Opt-In must be checked to continue / register?
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        setEventData({
                          ...eventData,
                          allowOptInVerify: e.target.checked,
                        });
                      }}
                      id="allowOptInVerify"
                      name="allowOptInVerify"
                      checked={eventData?.allowOptInVerify || false}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                <div className={formGroupCls}>
                  <label className="checkbox-container">
                    Opt-In below Submit Button?
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        setEventData({
                          ...eventData,
                          optInBelow: e.target.checked,
                        });
                      }}
                      id="optInBelow"
                      name="optInBelow"
                      checked={eventData?.optInBelow || false}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                <div
                  className={
                    !eventData?.disableRegistration ? formGroupCls : "hidden"
                  }
                >
                  <label className={labelCls}>Opt-In Language</label>
                  <select
                    className={inputCls}
                    id="optIn"
                    name="optIn"
                    onChange={(e) => {
                      setEventData({
                        ...eventData,
                        optInIndex: e.target.value,
                        optInCopy:
                          settings.optInDefaultCopy?.length > 0
                            ? settings.optInDefaultCopy[e.target.value]
                            : null,
                      });
                    }}
                    value={eventData?.optInIndex}
                  >
                    <option value=""></option>
                    {settings.optInDefaultCopy.map((optIn, index) => (
                      <option key={index} value={index}>
                        {optIn.name}
                      </option>
                    ))}
                  </select>
                </div>
                {eventData?.optInCopy && (
                  <div className="fs-xs pb-3">
                    {!showOptIn && (
                      <span
                        className="underline pointer"
                        onClick={() => {
                          setShowOptIn(true);
                        }}
                      >
                        Show Opt-In
                      </span>
                    )}
                    {showOptIn && (
                      <span
                        className="underline pointer"
                        onClick={() => {
                          setShowOptIn(false);
                        }}
                      >
                        Hide Opt-In
                      </span>
                    )}
                  </div>
                )}
                <div
                  className={eventData?.optInCopy && showOptIn ? "" : "hidden"}
                >
                  <div
                    className={!eventData?.disableRegistration ? "" : "hidden"}
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(eventData?.optInCopy?.content),
                    }}
                  ></div>
                </div>
                <div className={formGroupCls}>
                  <label className={labelCls}>
                    Default Registration Status
                  </label>
                  <select
                    className={inputCls}
                    id="defaultRegStatus"
                    name="defaultRegStatus"
                    onChange={handleChange}
                    value={eventData?.defaultRegStatus}
                  >
                    <option value="Registered">Registered</option>
                    <option value="Pending">Pending</option>
                    <option value="Waitlist">Waitlist</option>
                    <option value="Checked-In">Checked-In</option>
                    <option value="Completed">Completed</option>
                  </select>
                </div>
                <h3>Registration Alerts</h3>
                <div className={formGroupCls}>
                  <label className={labelCls}>Red Alert</label>
                  <select
                    className={`${inputCls} red-alert`}
                    id="redAlert"
                    name="redAlert"
                    onChange={handleChange}
                    value={eventData?.redAlert}
                  >
                    <option value=""></option>
                    {alertRules?.map((r, index) => (
                      <option key={index} value={r}>
                        {r}
                      </option>
                    ))}
                  </select>
                </div>
                <div className={formGroupCls}>
                  <label className={labelCls}>Yellow Alert</label>
                  <select
                    className={`${inputCls} yellow-alert`}
                    id="yellowAlert"
                    name="yellowAlert"
                    onChange={handleChange}
                    value={eventData?.yellowAlert}
                  >
                    <option value=""></option>
                    {alertRules?.map((r, index) => (
                      <option key={index} value={r}>
                        {r}
                      </option>
                    ))}
                  </select>
                </div>
                <div className={formGroupCls}>
                  <label className={labelCls}>Orange Alert</label>
                  <select
                    className={`${inputCls} orange-alert`}
                    id="orangeAlert"
                    name="orangeAlert"
                    onChange={handleChange}
                    value={eventData?.orangeAlert}
                  >
                    <option value=""></option>
                    {alertRules?.map((r, index) => (
                      <option key={index} value={r}>
                        {r}
                      </option>
                    ))}
                  </select>
                </div>
                <div className={formGroupCls}>
                  <label className={labelCls}>Purple Alert</label>
                  <select
                    className={`${inputCls} purple-alert`}
                    id="purpleAlert"
                    name="purpleAlert"
                    onChange={handleChange}
                    value={eventData?.purpleAlert}
                  >
                    <option value=""></option>
                    {alertRules?.map((r, index) => (
                      <option key={index} value={r}>
                        {r}
                      </option>
                    ))}
                  </select>
                </div>
                <div className={formGroupCls}>
                  <label className={labelCls}>Blue Alert</label>
                  <select
                    className={`${inputCls} blue-alert`}
                    id="blueAlert"
                    name="blueAlert"
                    onChange={handleChange}
                    value={eventData?.blueAlert}
                  >
                    <option value=""></option>
                    {alertRules?.map((r, index) => (
                      <option key={index} value={r}>
                        {r}
                      </option>
                    ))}
                  </select>
                </div>
                <div className={formGroupCls}>
                  <label className={labelCls}>Green Alert</label>
                  <select
                    className={`${inputCls} green-alert`}
                    id="greenAlert"
                    name="greenAlert"
                    onChange={handleChange}
                    value={eventData?.greenAlert}
                  >
                    <option value=""></option>
                    {alertRules?.map((r, index) => (
                      <option key={index} value={r}>
                        {r}
                      </option>
                    ))}
                  </select>
                </div>
              </>
            )}
          </div>
        )}
      </div>
      <div className={!eventData?.disableRegistration ? cardCls : "hidden"}>
        <div
          className={cardHeaderCls}
          onClick={() => {
            updateShowModules("passcodes", !showModules.passcodes);
          }}
        >
          <h2>Passcodes</h2>
          <div>
            <span className={showModules.passcodes ? "pe-3 text-xs font-bold" : "pe-3 text-xs"}>
              Show
            </span>
            <span className={!showModules.passcodes ? "text-xs font-bold" : "text-xs"}>Hide</span>
          </div>
        </div>
        {showModules.passcodes && (
          <div className={cardBodyCls}>
            <div className={formGroupCls}>
              <label className="checkbox-container">
                Use Passcodes?
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setEventData(
                      normalizePasscodeSettings({
                        ...eventData,
                        allowPasscodes: e.target.checked,
                      }),
                    );
                  }}
                  id="allowPasscodes"
                  name="allowPasscodes"
                  value="true"
                  checked={eventData?.allowPasscodes || false}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            {eventData?.allowPasscodes && (
              <>
                <div className={formGroupCls}>
                  <label className="checkbox-container">
                    Use Multi-Use Passcodes?
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        if (
                          !e.target.checked ||
                          (e.target.checked &&
                            !eventData?.allowSingleUsePasscodes)
                        ) {
                          setEventData({
                            ...eventData,
                            allowMultiUsePasscodes: e.target.checked,
                          });
                        } else {
                          alert(
                            "Disable single-use passcodes before enabling this feature.",
                          );
                        }
                      }}
                      id="allowMultiUsePasscodes"
                      name="allowMultiUsePasscodes"
                      value="true"
                      checked={eventData?.allowMultiUsePasscodes || false}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                {eventData?.allowMultiUsePasscodes && (
                  <>
                    <div className={formGroupCls}>
                      <label className="checkbox-container">
                        Require Multi-Use Passcodes (Admin)?
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            if (
                              e.target.checked &&
                              user.email.indexOf("core12.com") === -1
                            ) {
                              alert(
                                "Contact a Core12 Admin to enable this feature",
                              );
                            } else {
                              setEventData({
                                ...eventData,
                                requireMultiUsePasscodes: e.target.checked,
                              });
                            }
                          }}
                          id="requireMultiUsePasscodes"
                          name="requireMultiUsePasscodes"
                          value="true"
                          checked={eventData?.requireMultiUsePasscodes || false}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                    <h3>Multi-Use Passcodes</h3>
                    <div className="passcode-container">
                      <div className="text-right">
                        <button
                          className={primaryBtnCls}
                          onClick={() => {
                            // setPasscodeUserRefs([...passcodeUserRefs, React.createRef()]);
                            if (eventData?.multiUsePasscodes) {
                              setEventData({
                                ...eventData,
                                multiUsePasscodes: [
                                  ...eventData?.multiUsePasscodes,
                                  {},
                                ],
                              });
                            } else {
                              setEventData({
                                ...eventData,
                                multiUsePasscodes: [],
                              });
                            }
                          }}
                        >
                          + Multi-Use Passcode
                        </button>
                      </div>
                      <div className="py-3"></div>
                      {/* single = prefix and range | multi = code and allowed users */}
                      {eventData?.multiUsePasscodes?.map((pc, index) => (
                        <div key={index}>
                          <div className="flex flex-wrap gap-4 pb-2">
                            <div className="flex-1 min-w-0">
                              <div className={formGroupCls}>
                                <label className={labelCls}>Passcode</label>
                                <input
                                  type="text"
                                  onChange={(e) => {
                                    handleListChange(
                                      e,
                                      index,
                                      "multiUsePasscodes",
                                    );
                                  }}
                                  id={"passcode" + index}
                                  name="passcode"
                                  className={inputCls}
                                  value={
                                    eventData?.multiUsePasscodes[index].passcode
                                  }
                                />
                              </div>
                              <div className={formGroupCls}>
                                <label className={labelCls}>Label</label>
                                <input
                                  type="text"
                                  onChange={(e) => {
                                    handleListChange(
                                      e,
                                      index,
                                      "multiUsePasscodes",
                                    );
                                  }}
                                  id={"label" + index}
                                  name="label"
                                  className={inputCls}
                                  value={
                                    eventData?.multiUsePasscodes[index].label
                                  }
                                />
                              </div>
                              <div className={formGroupCls}>
                                <label className={labelCls}>Email</label>
                                <input
                                  type="text"
                                  onChange={(e) => {
                                    handleListChange(
                                      e,
                                      index,
                                      "multiUsePasscodes",
                                    );
                                  }}
                                  id={"email" + index}
                                  name="email"
                                  className={inputCls}
                                  value={
                                    eventData?.multiUsePasscodes[index].email
                                  }
                                />
                              </div>
                              <div className={formGroupCls}>
                                <label className={labelCls}>Details</label>
                                <input
                                  type="text"
                                  onChange={(e) => {
                                    handleListChange(
                                      e,
                                      index,
                                      "multiUsePasscodes",
                                    );
                                  }}
                                  id={"details" + index}
                                  name="details"
                                  className={inputCls}
                                  value={
                                    eventData?.multiUsePasscodes[index].details
                                  }
                                />
                              </div>
                              <div className={formGroupCls}>
                                <label className={labelCls}>
                                  Description
                                </label>
                                <input
                                  type="text"
                                  onChange={(e) => {
                                    handleListChange(
                                      e,
                                      index,
                                      "multiUsePasscodes",
                                    );
                                  }}
                                  id={"description" + index}
                                  name="description"
                                  className={inputCls}
                                  value={
                                    eventData?.multiUsePasscodes[index]
                                      .description
                                  }
                                />
                              </div>
                            </div>
                            {eventData?.requireMultiUsePasscodes && (
                              <div className="flex-1 min-w-0">
                                <div className={formGroupCls}>
                                  <label>Allowed Users</label>
                                  <Select
                                    classNamePrefix="manage-select"
                                    isMulti
                                    options={userList}
                                    getOptionLabel={(option) => option.name}
                                    getOptionValue={(option) => option.id || option.uid || option.email || option.name}
                                    value={
                                      eventData?.multiUsePasscodes[index]
                                        ?.usersAllowed || []
                                    }
                                    onChange={(selectedList) => {
                                      let tmpList =
                                        eventData["multiUsePasscodes"];
                                      tmpList[index] = {
                                        ...tmpList[index],
                                        usersAllowed: selectedList || [],
                                      };
                                      setEventData({
                                        ...eventData,
                                        multiUsePasscodes: tmpList,
                                      });
                                    }}
                                  />
                                </div>
                                <div className={formGroupCls}>
                                  <label>Assigned Dealer</label>
                                  <Select
                                    classNamePrefix="manage-select"
                                    value={dealerOptions.find(
                                      (o) =>
                                        o.value ===
                                        eventData?.multiUsePasscodes[index]
                                          .dealer,
                                    )}
                                    onChange={(e) => {
                                      handleListChange(
                                        { target: { name: "dealer" } },
                                        index,
                                        "multiUsePasscodes",
                                        false,
                                        e.value,
                                      );
                                    }}
                                    options={dealerOptions}
                                    filterOption={filterDealerOption}
                                    aria-label="Assigned Dealer"
                                    required={
                                      eventData?.dataFields.dealer?.visible &&
                                      eventData?.dataFields.dealer?.required
                                        ? true
                                        : false
                                    }
                                  />
                                </div>
                                <div className={formGroupCls}>
                                  <label className="checkbox-container">
                                    Disable All Leads to C@P?
                                    <input
                                      type="checkbox"
                                      onChange={(e) => {
                                        handleListChange(
                                          {
                                            target: { name: "disableAllLeads" },
                                          },
                                          index,
                                          "multiUsePasscodes",
                                          false,
                                          e.target.checked,
                                        );
                                      }}
                                      id="disableAllLeads"
                                      name="disableAllLeads"
                                      value="true"
                                      checked={
                                        eventData?.multiUsePasscodes[index]
                                          .disableAllLeads || false
                                      }
                                    />
                                    <span className="checkmark"></span>
                                  </label>
                                </div>
                              </div>
                            )}
                          </div>
                          <div className="text-right pb-3">
                            <i
                              className="del-icon ml-2"
                              onClick={(e) => {
                                let tmpMultiUsePasscodes =
                                  eventData?.multiUsePasscodes;
                                tmpMultiUsePasscodes.splice(index, 1);
                                // let tmpPasscodeUserRefs = passcodeUserRefs;
                                // tmpPasscodeUserRefs.splice(index, 1);
                                // setPasscodeUserRefs(tmpPasscodeUserRefs);
                                setEventData({
                                  ...eventData,
                                  multiUsePasscodes: tmpMultiUsePasscodes,
                                });
                              }}
                            >
                              <DeleteIcon />
                            </i>{" "}
                            Multi-Use Passcode
                          </div>
                        </div>
                      ))}
                      <div className="py-2"></div>
                    </div>
                  </>
                )}
                <div className={formGroupCls}>
                  <label className="checkbox-container">
                    Use Single-Use Passcodes?
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        if (
                          e.target.checked &&
                          user.email.indexOf("core12.com") === -1
                        ) {
                          alert(
                            "Contact a Core12 Admin to enable this feature",
                          );
                        } else if (
                          !e.target.checked ||
                          (e.target.checked &&
                            !eventData?.allowMultiUsePasscodes)
                        ) {
                          setEventData({
                            ...eventData,
                            allowSingleUsePasscodes: e.target.checked,
                          });
                        } else {
                          alert(
                            "Disable multi-use passcodes before enabling this feature.",
                          );
                        }
                      }}
                      id="allowSingleUsePasscodes"
                      name="allowSingleUsePasscodes"
                      value="true"
                      checked={eventData?.allowSingleUsePasscodes || false}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                {eventData?.allowSingleUsePasscodes && (
                  <>
                    <h3>Single-Use Passcodes</h3>
                    <div className="passcode-container">
                      <div className="text-right">
                        <button
                          className={primaryBtnCls}
                          onClick={() => {
                            if (eventData?.singleUsePasscodes) {
                              setEventData({
                                ...eventData,
                                singleUsePasscodes: [
                                  ...eventData?.singleUsePasscodes,
                                  {},
                                ],
                              });
                            } else {
                              setEventData({
                                ...eventData,
                                singleUsePasscodes: [],
                              });
                            }
                          }}
                        >
                          + Single-Use Passcode
                        </button>
                      </div>
                      <div className="py-3"></div>
                      {/* single = prefix and range | multi = code and allowed users */}
                      {eventData?.singleUsePasscodes?.map((pc, index) => (
                        <div key={index}>
                          <div className="flex flex-wrap gap-4 pb-2 items-center">
                            <div className="w-1/4">
                              <div className={formGroupCls}>
                                <label className={labelCls}>Prefix</label>
                                <input
                                  type="text"
                                  onChange={(e) => {
                                    if (e.target.value.length <= 3)
                                      handleListChange(
                                        e,
                                        index,
                                        "singleUsePasscodes",
                                      );
                                  }}
                                  id={"prefix" + index}
                                  name="prefix"
                                  className={inputCls}
                                  value={
                                    eventData?.singleUsePasscodes[index].prefix
                                  }
                                />
                              </div>
                            </div>
                            <div className="w-1/6">
                              <div className={formGroupCls}>
                                <label className={labelCls}>Low</label>
                                <input
                                  type="number"
                                  onChange={(e) => {
                                    handleListChange(
                                      e,
                                      index,
                                      "singleUsePasscodes",
                                    );
                                  }}
                                  id={"low" + index}
                                  name="low"
                                  className={inputCls}
                                  value={
                                    eventData?.singleUsePasscodes[index].low
                                  }
                                  maxlength="3"
                                />
                              </div>
                            </div>
                            <div className="w-1/6">
                              <div className={formGroupCls}>
                                <label className={labelCls}>High</label>
                                <input
                                  type="number"
                                  onChange={(e) => {
                                    handleListChange(
                                      e,
                                      index,
                                      "singleUsePasscodes",
                                    );
                                  }}
                                  id={"high" + index}
                                  name="high"
                                  className={inputCls}
                                  value={
                                    eventData?.singleUsePasscodes[index].high
                                  }
                                />
                              </div>
                            </div>
                            <div className="w-1/6">
                              <div className={formGroupCls}>
                                <label className="checkbox-container">
                                  Allow Auto Assign
                                  <input
                                    type="checkbox"
                                    onChange={(e) => {
                                      handleListChange(
                                        e,
                                        index,
                                        "singleUsePasscodes",
                                        true,
                                      );
                                    }}
                                    id={"autoAssign" + index}
                                    name="autoAssign"
                                    checked={
                                      eventData?.singleUsePasscodes[index]
                                        .autoAssign || false
                                    }
                                  />
                                  <span className="checkmark"></span>
                                </label>
                              </div>
                              <div className={formGroupCls}>
                                <label className="checkbox-container">
                                  Assigned Sessions
                                  <input
                                    type="checkbox"
                                    onChange={(e) => {
                                      handleListChange(
                                        e,
                                        index,
                                        "singleUsePasscodes",
                                        true,
                                      );
                                    }}
                                    id={"assignedSessions" + index}
                                    name="assignedSessions"
                                    checked={
                                      eventData?.singleUsePasscodes[index]
                                        .assignedSessions || false
                                    }
                                  />
                                  <span className="checkmark"></span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="text-right pb-3">
                            <i
                              className="del-icon ml-2"
                              onClick={(e) => {
                                let tmpSingleUsePasscodes =
                                  eventData?.singleUsePasscodes;
                                tmpSingleUsePasscodes.splice(index, 1);
                                setEventData({
                                  ...eventData,
                                  singleUsePasscodes: tmpSingleUsePasscodes,
                                });
                              }}
                            >
                              <DeleteIcon />
                            </i>{" "}
                            Single-Use Passcode
                          </div>
                        </div>
                      ))}
                      <div className="py-2"></div>
                    </div>
                    <div>
                      <button
                        className={primaryBtnCls}
                        onClick={(e) => {
                          alert("contact support");
                        }}
                      >
                        Download Passcodes
                      </button>
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        )}
      </div>
      <div className={!eventData?.disableRegistration ? cardCls : "hidden"}>
        <div
          className={cardHeaderCls}
          onClick={() => {
            updateShowModules("capacities", !showModules.capacities);
          }}
        >
          <h2>Capacities & Sessions</h2>
          <div>
            <span className={showModules.capacities ? "pe-3 text-xs font-bold" : "pe-3 text-xs"}>
              Show
            </span>
            <span className={!showModules.capacities ? "text-xs font-bold" : "text-xs"}>
              Hide
            </span>
          </div>
        </div>
        {showModules.capacities && (
          <div className={cardBodyCls}>
            <div
              className={
                !eventData?.disableRegistration ? formGroupCls : "hidden"
              }
            >
              <label className="checkbox-container">
                Limit capacity at the event.
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setEventData({
                      ...eventData,
                      allowCapacity: e.target.checked,
                    });
                  }}
                  id="allowCapacity"
                  name="allowCapacity"
                  checked={eventData?.allowCapacity || false}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            {!eventData?.disableRegistration && (
              <div className={formGroupCls}>
                <label
                  className={labelCls + " form-help"}
                  onClick={() => {
                    setHelp({ ...help, capacityTitle: !help.capacityTitle });
                  }}
                >
                  Capacity Title{" "}
                  <i className="xs">
                    <InfoIcon />
                  </i>
                </label>
                <div className={help.capacityTitle ? "fs-xs" : "hidden"}>
                  Capacity title to replace standard title on the page.
                </div>
                <input
                  type="text"
                  id="capacityTitle"
                  name="capacityTitle"
                  value={eventData?.capacityTitle || ""}
                  onChange={handleChange}
                  className={inputCls}
                  placeholder="The event is at capacity."
                />
              </div>
            )}
            <div
              className={
                !eventData?.disableRegistration ? `${formGroupCls} pb-3` : "hidden"
              }
            >
              <h2>Capacity Copy</h2>
              <div className="copy-container">
                <div
                  className={
                    eventData?.capacityCopy ? "mb-3 p-2 edit-copy" : "hidden"
                  }
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(eventData?.capacityCopy),
                  }}
                ></div>
                <button
                  className={secondaryBtnCls}
                  onClick={() => {
                    setEditCopy("capacityCopy");
                  }}
                >
                  Edit Capacity Copy
                </button>
              </div>
            </div>
            {eventData?.allowCapacity && (
              <>
                <div className={formGroupCls}>
                  <label className={labelCls}>Capacity Type</label>
                  <select
                    className={inputCls}
                    id="capacityType"
                    name="capacityType"
                    onChange={(e) => {
                      if (
                        e.target.value === "session" &&
                        user.email.indexOf("core12.com") === -1
                      ) {
                        alert("Contact a Core12 Admin to enable this feature");
                      } else {
                        setEventData({
                          ...eventData,
                          capacityType: e.target.value,
                        });
                      }
                    }}
                    value={eventData?.capacityType || ""}
                  >
                    <option value="">Basic</option>
                    <option value="session">Session</option>
                  </select>
                </div>
                {(!eventData?.capacityType ||
                  eventData?.capacityType === "") && (
                  <>
                    <div className={formGroupCls}>
                      <label className={labelCls}>Capacity</label>
                      <input
                        type="number"
                        id="capacity"
                        name="capacity"
                        value={eventData?.capacity || 0}
                        onChange={handleChange}
                        className={inputCls}
                      />
                    </div>
                    <div className={formGroupCls}>
                      <label className="checkbox-container">
                        Attendees can bring a guest?
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            setEventData({
                              ...eventData,
                              allowGuests: e.target.checked,
                            });
                          }}
                          id="allowGuests"
                          name="allowGuests"
                          checked={eventData?.allowGuests || false}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                    {eventData?.allowGuests ? (
                      <>
                        <div className={formGroupCls}>
                          <label className="checkbox-container">
                            Collect Guest Details
                            <input
                              type="checkbox"
                              onChange={(e) => {
                                setEventData({
                                  ...eventData,
                                  allowGuestDetails: e.target.checked,
                                });
                              }}
                              id="allowGuestDetails"
                              name="allowGuestDetails"
                              checked={eventData?.allowGuestDetails || false}
                            />
                            <span className="checkmark"></span>
                          </label>
                        </div>
                        <div className={formGroupCls}>
                          <label className={labelCls}>Guest Message</label>
                          <input
                            type="text"
                            id="guestMessage"
                            name="guestMessage"
                            placeholder="Would you like to bring a non-driving guest to ride along with you during the event?"
                            value={eventData?.guestMessage || ""}
                            onChange={handleChange}
                            className={inputCls}
                          />
                        </div>
                        <div className={formGroupCls}>
                          <label className="checkbox-container">
                            Collect Guest Waiver
                            <input
                              type="checkbox"
                              onChange={(e) => {
                                setEventData({
                                  ...eventData,
                                  allowGuestWaiver: e.target.checked,
                                });
                              }}
                              id="allowGuestWaiver"
                              name="allowGuestWaiver"
                              checked={eventData?.allowGuestWaiver || false}
                            />
                            <span className="checkmark"></span>
                          </label>
                        </div>
                        <div className={formGroupCls}>
                          <label className="checkbox-container">
                            Guests count towards capacity?
                            <input
                              type="checkbox"
                              onChange={(e) => {
                                setEventData({
                                  ...eventData,
                                  allowGuestCapacity: e.target.checked,
                                });
                              }}
                              id="allowGuestCapacity"
                              name="allowGuestCapacity"
                              checked={eventData?.allowGuestCapacity || false}
                            />
                            <span className="checkmark"></span>
                          </label>
                        </div>
                      </>
                    ) : (
                      <div></div>
                    )}
                  </>
                )}
                {eventData?.capacityType === "session" && (
                  <>
                    <div className={formGroupCls}>
                      <label className="checkbox-container">
                        Sessions can be overbooked by Manager and Admin?
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            setEventData({
                              ...eventData,
                              allowOverbooking: e.target.checked,
                            });
                          }}
                          id="allowOverbooking"
                          name="allowOverbooking"
                          checked={eventData?.allowOverbooking || false}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                    <div className={formGroupCls}>
                      <label className="checkbox-container">
                        Attendees can bring a tag-along guest? (guests do not
                        count against capacity)
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            setEventData({
                              ...eventData,
                              allowGuests: e.target.checked,
                            });
                          }}
                          id="allowGuests"
                          name="allowGuests"
                          checked={eventData?.allowGuests || false}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                    {eventData?.allowGuests && (
                      <>
                        <div className={formGroupCls}>
                          <label className="checkbox-container">
                            Collect Guest Waiver
                            <input
                              type="checkbox"
                              onChange={(e) => {
                                setEventData({
                                  ...eventData,
                                  allowGuestWaiver: e.target.checked,
                                });
                              }}
                              id="allowGuestWaiver"
                              name="allowGuestWaiver"
                              checked={eventData?.allowGuestWaiver || false}
                            />
                            <span className="checkmark"></span>
                          </label>
                        </div>
                        <div className={formGroupCls}>
                          <label className={labelCls}>Guest Message</label>
                          <input
                            type="text"
                            id="guestMessage"
                            name="guestMessage"
                            placeholder="Would you like to bring a non-driving guest to ride along with you during the event?"
                            value={eventData?.guestMessage || ""}
                            onChange={handleChange}
                            className={inputCls}
                          />
                        </div>
                      </>
                    )}
                    <div className={formGroupCls}>
                      <label className="checkbox-container">
                        Send SMS Reminders
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            setEventData({
                              ...eventData,
                              allowSMSReminders: e.target.checked,
                            });
                          }}
                          id="allowSMSReminders"
                          name="allowSMSReminders"
                          checked={eventData?.allowSMSReminders || false}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                    {eventData?.allowSMSReminders && (
                      <>
                        <div className={formGroupCls}>
                          <label className={labelCls}>
                            SMS Reminder Message
                          </label>
                          <textarea
                            id="smsReminderMessage"
                            name="smsReminderMessage"
                            onChange={handleChange}
                            className={inputCls}
                            value={eventData?.smsReminderMessage || ""}
                          ></textarea>
                        </div>
                        <div className={formGroupCls}>
                          <label className={labelCls}>
                            Minutes Before Session Time
                          </label>
                          <input
                            type="number"
                            id="smsReminderMinutes"
                            name="smsReminderMinutes"
                            onChange={handleChange}
                            className={inputCls}
                            value={eventData?.smsReminderMinutes || ""}
                          />
                        </div>
                        <div className={formGroupCls}>
                          <label className={labelCls}>Event Time Zone</label>
                          <select
                            id="smsReminderTimezone"
                            name="smsReminderTimezone"
                            onChange={handleChange}
                            className={inputCls}
                            value={eventData?.smsReminderTimezone || ""}
                          >
                            <option value=""></option>
                            <option value="America/Chicago">
                              America/Chicago (CST)
                            </option>
                            <option value="America/New_York">
                              America/New_York (EST)
                            </option>
                            <option value="America/Los_Angeles">
                              America/Los_Angeles (PST)
                            </option>
                            <option value="America/Denver">
                              America/Denver (MST)
                            </option>
                          </select>
                          <div className="pt-3">
                            Current Event Time:{" "}
                            {moment()
                              .tz(eventData?.smsReminderTimezone)
                              ?.format("MM/DD/YYYY h:mm A")}
                          </div>
                        </div>
                      </>
                    )}

                    <h3>Session Items</h3>
                    <div className="session-container">
                      <div className="text-right">
                        <button
                          className={primaryBtnCls}
                          onClick={() => {
                            if (eventData?.sessionItems) {
                              setEventData({
                                ...eventData,
                                sessionItems: [...eventData?.sessionItems, {}],
                              });
                            } else {
                              setEventData({
                                ...eventData,
                                sessionItems: [],
                              });
                            }
                          }}
                        >
                          + Session Item
                        </button>
                      </div>
                      <div className="py-3"></div>
                      {/* single = prefix and range | multi = code and allowed users */}
                      {eventData?.sessionItems?.map((pc, index) => (
                        <div key={index}>
                          <div className="flex flex-wrap gap-4 pb-2">
                            <div className="flex-1 min-w-0">
                              <div className={formGroupCls}>
                                <label className={labelCls}>Name</label>
                                <input
                                  type="text"
                                  onChange={(e) => {
                                    handleListChange(e, index, "sessionItems");
                                  }}
                                  id={"name" + index}
                                  name="name"
                                  className={inputCls}
                                  value={eventData?.sessionItems[index].name}
                                />
                              </div>
                            </div>
                            <div className="flex-1 min-w-0">
                              <div className={formGroupCls}>
                                <label className={labelCls}>Slug</label>
                                <input
                                  type="text"
                                  onChange={(e) => {
                                    handleListChange(e, index, "sessionItems");
                                  }}
                                  id={"slug" + index}
                                  name="slug"
                                  className={inputCls}
                                  value={eventData?.sessionItems[index].slug}
                                />
                              </div>
                            </div>
                          </div>
                          <div>
                            <div className={formGroupCls}>
                              <label className={labelCls}>Description</label>
                              <textarea
                                onChange={(e) => {
                                  handleListChange(e, index, "sessionItems");
                                }}
                                id={"description" + index}
                                name="description"
                                className={inputCls}
                                rows="10"
                                value={
                                  eventData?.sessionItems[index].description
                                }
                              ></textarea>
                            </div>
                          </div>
                          <div className="text-right pb-3">
                            <i
                              className="del-icon ml-2"
                              onClick={(e) => {
                                let tmpSessionItems = eventData?.sessionItems;
                                tmpSessionItems.splice(index, 1);
                                setEventData({
                                  ...eventData,
                                  sessionItems: tmpSessionItems,
                                });
                              }}
                            >
                              <DeleteIcon />
                            </i>{" "}
                            Session Item
                          </div>
                        </div>
                      ))}
                      <div className="py-2"></div>
                      <h3>Sessions</h3>
                      <div className={formGroupCls}>
                        <label className={labelCls}>CSV Output</label>
                        <textarea
                          id="sessions"
                          name="sessions"
                          onChange={handleCSVChange}
                          className={inputCls}
                          value=""
                        ></textarea>
                      </div>
                      {sessionData && (
                        <div className="fs-xs pb-3">
                          {!showSessions && (
                            <span
                              className="underline pointer"
                              onClick={() => {
                                setShowSessions(true);
                              }}
                            >
                              Show Sessions
                            </span>
                          )}
                          {showSessions && (
                            <span
                              className="underline pointer"
                              onClick={() => {
                                setShowSessions(false);
                              }}
                            >
                              Hide Sessions
                            </span>
                          )}
                        </div>
                      )}
                      {sessionData && showSessions && (
                        <>
                          <div className="py-2"></div>
                          <JsonViewer data={sessionData} />
                          {/* {sessionData?.map((s, index) => (
                        <div className="flex flex-wrap gap-4">
                          <div className="w-1/12">
                            {s.id}
                          </div>
                          <div className="w-1/4">
                            {eventData?.sessionItems[s.itemIndex]?.name}
                          </div>
                          <div className="w-1/3">
                            {s.startTime}
                          </div>
                          <div className="w-1/12">
                            {s.lockCreatedOn}
                          </div>
                          <div className="w-1/12">
                            {s.reserved}
                          </div>
                          <div className="w-1/6">
                            {s.passcode}
                            </div>
</div>
                    ))}  */}
                        </>
                      )}
                      <div className={formGroupCls}>
                        <label
                          className={labelCls + " form-help"}
                          onClick={() => {
                            setHelp({
                              ...help,
                              sessionLabel: !help.sessionLabel,
                            });
                          }}
                        >
                          Alternate Session Label{" "}
                          <i className="xs">
                            <InfoIcon />
                          </i>
                        </label>
                        <div className={help.submitButton ? "fs-xs" : "hidden"}>
                          Alternate session label instead of Select Date & Time
                        </div>
                        <input
                          type="text"
                          id="sessionLabel"
                          name="sessionLabel"
                          value={eventData?.sessionLabel || ""}
                          onChange={handleChange}
                          className={inputCls}
                        />
                      </div>
                      <div className={formGroupCls}>
                        <label
                          className={labelCls + " form-help"}
                          onClick={() => {
                            setHelp({
                              ...help,
                              sessionLabel: !help.sessionLabel,
                            });
                          }}
                        >
                          Days Ahead{" "}
                          <i className="xs">
                            <InfoIcon />
                          </i>
                        </label>
                        <div className={help.submitButton ? "fs-xs" : "hidden"}>
                          Days in advance that a session can be selected from
                          the front end.
                        </div>
                        <input
                          type="number"
                          id="daysAhead"
                          name="daysAhead"
                          value={eventData?.daysAhead || ""}
                          onChange={handleChange}
                          className={inputCls}
                        />
                      </div>
                      <div className={formGroupCls}>
                        <label className="checkbox-container">
                          Hide Session Times
                          <input
                            type="checkbox"
                            onChange={(e) => {
                              setEventData({
                                ...eventData,
                                hideSessionTimes: e.target.checked,
                              });
                            }}
                            id="hideSessionTimes"
                            name="hideSessionTimes"
                            checked={eventData?.hideSessionTimes || false}
                          />
                          <span className="checkmark"></span>
                        </label>
                      </div>
                      <div className={formGroupCls}>
                        <label className="checkbox-container">
                          Condensed Sessions
                          <input
                            type="checkbox"
                            onChange={(e) => {
                              setEventData({
                                ...eventData,
                                condensedSessions: e.target.checked,
                              });
                            }}
                            id="condensedSessions"
                            name="condensedSessions"
                            checked={eventData?.condensedSessions || false}
                          />
                          <span className="checkmark"></span>
                        </label>
                      </div>
                      <div className="py-2"></div>
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        )}
      </div>
      <div className={!eventData?.disableRegistration ? cardCls : "hidden"}>
        <div
          className={cardHeaderCls}
          onClick={() => {
            updateShowModules("leads", !showModules.leads);
          }}
        >
          <h2>C@P Lead Processing</h2>
          <div>
            <span className={showModules.leads ? "pe-3 text-xs font-bold" : "pe-3 text-xs"}>
              Show
            </span>
            <span className={!showModules.leads ? "text-xs font-bold" : "text-xs"}>Hide</span>
          </div>
        </div>
        {showModules.leads && (
          <div className={cardBodyCls}>
            <div className={formGroupCls}>
              <label className="checkbox-container">
                Send Event Data to C@P
                <input
                  type="checkbox"
                  disabled={!!eventData?.capRequestId}
                  onChange={(e) => {
                    if (Number(user.role) === 1 ||
                        user.email?.toLowerCase().endsWith("@core12.com")) {
                      setEventData({
                        ...eventData,
                        allowPushToCap: e.target.checked,
                      });
                    } else {
                      alert("Contact a Core12 Admin to enable this feature");
                    }
                  }}
                  id="allowPushToCap"
                  name="allowPushToCap"
                  checked={eventData?.allowPushToCap || false}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            <CampaignRequestLinkControl event={eventData} eventId={id || eventData?.id}
              requests={campaignCodes} user={user} onLinked={loadInit} />
            {eventData?.capRequestId && campaignRequestMismatch(eventData,
              campaignCodes.find((option) => option.value.id === eventData.capRequestId)?.value) &&
              <p className="mb-4 text-sm text-red-700 dark:text-red-300">
                Event C@P settings differ from the approved request. Reapply it before saving.
              </p>}
            {eventData?.allowPushToCap && (
              <>
                {!eventData?.capRequestId && originalEvent.current?.allowPushToCap &&
                  !originalEvent.current?.capRequestId &&
                  <p className="mb-4 text-sm text-amber-700 dark:text-amber-300">
                    This existing event can be saved without a linked request. C@P export
                    still requires an audited legacy exemption.
                  </p>}
                <div className={formGroupCls}>
                  <label className={labelCls}>Campaign Code</label>
                  <input
                    disabled={!!eventData?.capRequestId}
                    type="text"
                    id="campaignCode"
                    name="campaignCode"
                    value={eventData?.campaignCode || ""}
                    onChange={handleChange}
                    className={inputCls}
                  />
                </div>
                <div className={formGroupCls}>
                  <label className={labelCls}>Campaign Description</label>
                  <input
                    disabled={!!eventData?.capRequestId}
                    type="text"
                    id="campaignDescription"
                    name="campaignDescription"
                    value={eventData?.campaignDescription || ""}
                    onChange={handleChange}
                    className={inputCls}
                  />
                </div>
                <div className={formGroupCls}>
                  <label className={labelCls}>
                    Campaign Interaction History Code
                  </label>
                  <input
                    disabled={!!eventData?.capRequestId}
                    type="text"
                    id="campaignAltCode"
                    name="campaignAltCode"
                    value={eventData?.campaignAltCode || ""}
                    onChange={handleChange}
                    className={inputCls}
                  />
                </div>
                <div className={formGroupCls}>
                  <label className={labelCls}>
                    Campaign Interaction History Description
                  </label>
                  <input
                    disabled={!!eventData?.capRequestId}
                    type="text"
                    id="campaignAltDescription"
                    name="campaignAltDescription"
                    value={eventData?.campaignAltDescription || ""}
                    onChange={handleChange}
                    className={inputCls}
                  />
                </div>
                <div className={formGroupCls}>
                  <label className={labelCls}>Campaign Comments</label>
                  <input
                    disabled={!!eventData?.capRequestId}
                    type="text"
                    id="campaignComments"
                    name="campaignComments"
                    value={eventData?.campaignComments || ""}
                    onChange={handleChange}
                    className={inputCls}
                  />
                </div>
                <div className="flex flex-wrap gap-4 items-center">
                  <div className="flex-1 min-w-0">
                    <div className={formGroupCls}>
                      <label className="checkbox-container">
                        Process leads for all checked-in/completed registrations
                        <input
                          // disabled={eventData?.pushToCapCompleted}
                          type="checkbox"
                          onChange={(e) => {
                            if (user.email.indexOf("core12.com") > -1) {
                              setEventData({
                                ...eventData,
                                checkedInLeads: e.target.checked,
                              });
                            } else {
                              alert(
                                "Contact a Core12 Admin to enable this feature",
                              );
                            }
                          }}
                          id="checkedInLeads"
                          name="checkedInLeads"
                          disabled={!!eventData?.capRequestId}
                          checked={eventData?.checkedInLeads || false}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                    <div className={formGroupCls}>
                      <label className={labelCls} htmlFor="dealerOptInMode">
                        Dealer contact opt-in question
                      </label>
                      <select
                        className={inputCls}
                        id="dealerOptInMode"
                        name="dealerOptInMode"
                        disabled={!!eventData?.capRequestId}
                        value={getDealerOptInMode(eventData)}
                        onChange={(e) => {
                          if (user.email.indexOf("core12.com") > -1) {
                            setEventData({
                              ...eventData,
                              ...dealerOptInModeFlags(e.target.value),
                            });
                          } else {
                            alert(
                              "Contact a Core12 Admin to enable this feature",
                            );
                          }
                        }}
                      >
                        <option value="always">
                          Ask always, including waitlist
                        </option>
                        <option value="hideOnWaitlist">
                          Hide on waitlist registration
                        </option>
                        <option value="skip">Skip always</option>
                      </select>
                      <p className="mt-2 text-xs text-zinc-500 dark:text-zinc-400">
                        Skip always hides the Porsche Center contact question.
                        Hide on waitlist keeps it for registered attendees.
                        Ask always requires it for waitlist joiners too.
                      </p>
                    </div>
                    {!eventData?.ongoingEvent && (
                      <div className={formGroupCls}>
                        <label className="checkbox-container">
                          Process leads at end of event.
                          <input
                            // disabled={eventData?.pushToCapCompleted}
                            type="checkbox"
                            onChange={(e) => {
                              if (user.email.indexOf("core12.com") > -1) {
                                setEventData({
                                  ...eventData,
                                  endOfEvent: e.target.checked,
                                });
                              } else {
                                alert(
                                  "Contact a Core12 Admin to enable this feature",
                                );
                              }
                            }}
                            id="endOfEvent"
                            name="endOfEvent"
                            disabled={!!eventData?.capRequestId}
                            checked={eventData?.endOfEvent || false}
                          />
                          <span className="checkmark"></span>
                        </label>
                      </div>
                    )}
                    <div className={formGroupCls}>
                      <label className="checkbox-container">
                        Approved by Stakeholder & CRM
                        <input
                          // disabled={eventData?.pushToCapCompleted}
                          type="checkbox"
                          onChange={(e) => {
                            if (user.email.indexOf("core12.com") > -1) {
                              setEventData({
                                ...eventData,
                                campaignCodeVerified: e.target.checked,
                              });
                            } else {
                              alert(
                                "Contact a Core12 Admin to enable this feature",
                              );
                            }
                          }}
                          id="campaignCodeVerified"
                          name="campaignCodeVerified"
                          disabled={!!eventData?.capRequestId}
                          checked={eventData?.campaignCodeVerified || false}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        )}
      </div>
      <div className={!eventData?.disableRegistration ? cardCls : "hidden"}>
        <div
          className={cardHeaderCls}
          onClick={() => {
            updateShowModules("fields", !showModules.fields);
          }}
        >
          <h2>Data Fields</h2>
          <div>
            <span
              onClick={() => {
                updateShowModules("fields", true);
              }}
              className={showModules.fields ? "pe-3 text-xs font-bold" : "pe-3 text-xs"}
            >
              Show
            </span>
            <span
              onClick={() => {
                updateShowModules("fields", false);
              }}
              className={!showModules.fields ? "text-xs font-bold" : "text-xs"}
            >
              Hide
            </span>
          </div>
        </div>
        {showModules.fields && (
          <div className={cardBodyCls}>
            <h3>CRM Data Fields</h3>
            {CRM_DATA_FIELD_EDITOR_ROWS.slice(0, 6).map((row) => (
              <EventCrmDataField
                key={row.fieldKey}
                fieldKey={row.fieldKey}
                label={row.label}
                eventData={eventData}
                setEventData={setEventData}
                formGroupCls={formGroupCls}
              />
            ))}
            <div className="flex flex-wrap gap-4">
              <div className="flex-1 min-w-0">Google Address Lookup </div>

              <div className="flex-none">
                <div className={formGroupCls}>
                  <label className="checkbox-container">
                    Enable Google Address Lookup
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        if (e.target.checked) {
                          setEventData({
                            ...eventData,
                            addressLookup: e.target.checked,
                            dataFields: {
                              ...eventData?.dataFields,
                              address1: {
                                ...eventData?.dataFields?.address1,
                                visible: e.target.checked,
                              },
                              city: {
                                ...eventData?.dataFields?.city,
                                visible: e.target.checked,
                              },
                              state: {
                                ...eventData?.dataFields?.state,
                                visible: e.target.checked,
                              },
                              postal: {
                                ...eventData?.dataFields?.postal,
                                visible: e.target.checked,
                              },
                            },
                          });
                        } else {
                          setEventData({
                            ...eventData,
                            addressLookup: e.target.checked,
                          });
                        }
                      }}
                      id="addressLookup"
                      name="addressLookup"
                      checked={eventData?.addressLookup || false}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
            {CRM_DATA_FIELD_EDITOR_ROWS.slice(6).map((row) => (
              <EventCrmDataField
                key={row.fieldKey}
                fieldKey={row.fieldKey}
                label={row.label}
                eventData={eventData}
                setEventData={setEventData}
                formGroupCls={formGroupCls}
              />
            ))}
            <div
              className={
                eventData?.dataFields?.dealer?.visible ||
                eventData?.dataFields?.dealer?.adminOnly
                  ? formGroupCls
                  : "hidden"
              }
            >
              <div>
                Choose which dealers to show in the dropdown. Leave empty to
                show all dealers.
              </div>
              <Select
                classNamePrefix="manage-select"
                isMulti
                options={dealers.filter((dealer) => dealer.active !== false)}
                getOptionLabel={formatDealerLabel}
                getOptionValue={(option) => option.code}
                filterOption={filterDealerOption}
                aria-label="Dealers available for registration"
                placeholder="Search Porsche Center, city, state or postal code"
                value={eventData?.dealersSelected || []}
                onChange={(selectedList) => {
                  setEventData({
                    ...eventData,
                    dealersSelected: (selectedList || []).map(toDealerSelection),
                  });
                }}
              />
            </div>
            <div
              className={
                eventData?.dataFields?.modelInterest?.visible ||
                eventData?.dataFields?.modelInterest?.adminOnly
                  ? formGroupCls
                  : "hidden"
              }
            >
              <div>
                Choose which models to show in the dropdown. Leave empty to
                show all models.
              </div>
              <Select
                classNamePrefix="manage-select"
                isMulti
                inputId="modelsSelected"
                options={resolveModelInterestCatalog(
                  settings?.modelInterestOptions,
                )}
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.value}
                value={normalizeModelInterestSelection(
                  eventData?.modelsSelected,
                  settings?.modelInterestOptions,
                )}
                onChange={(selectedList) => {
                  setEventData({
                    ...eventData,
                    modelsSelected: selectedList || [],
                  });
                }}
              />
            </div>
            <h3>Additional Data Fields</h3>
            <div className="flex flex-wrap justify-end gap-2">
              <button
                className={`${secondaryBtnCls} min-h-11 disabled:cursor-not-allowed disabled:opacity-50`}
                disabled={!eventData?.additionalFields?.length}
                onClick={() => setAllAdditionalFieldsExpanded(true)}
                type="button"
              >
                Expand all
              </button>
              <button
                className={`${secondaryBtnCls} min-h-11 disabled:cursor-not-allowed disabled:opacity-50`}
                disabled={!eventData?.additionalFields?.length}
                onClick={() => setAllAdditionalFieldsExpanded(false)}
                type="button"
              >
                Collapse all
              </button>
              <button
                className={primaryBtnCls}
                onClick={addAdditionalField}
                type="button"
              >
                + DATA FIELD
              </button>
            </div>
            <div className="py-3"></div>
            {eventData?.additionalFields?.map((cta, index) => (
              <EventAdditionalField
                item={cta}
                key={index}
                id={index}
                index={index}
                isExpanded={additionalFieldExpansion[index] ?? true}
                moveField={moveField}
                onDuplicate={duplicateField}
                onRemove={removeAdditionalField}
                onToggleExpanded={() =>
                  setAdditionalFieldExpanded(
                    index,
                    !(additionalFieldExpansion[index] ?? true),
                  )
                }
                totalFields={eventData.additionalFields.length}
                eventData={eventData}
                setEventData={setEventData}
              />
            ))}
            <div className="py-2"></div>
            <div className={formGroupCls}>
              <label
                className={labelCls + " form-help"}
                onClick={() => {
                  setHelp({
                    ...help,
                    paymentTaxPercent: !help.paymentTaxPercent,
                  });
                }}
              >
                Payment Tax %
                <i className="xs">
                  <InfoIcon />
                </i>
              </label>
              <div className={help.paymentTaxPercent ? "fs-xs" : "hidden"}>
                Tax % for Payment.
              </div>
              <input
                type="number"
                id="paymentTax"
                name="paymentTax"
                step="any"
                value={eventData?.paymentTax || 0}
                onChange={handleChange}
                className={inputCls}
              />
            </div>
            <div className={formGroupCls}>
              <label
                className={labelCls + " form-help"}
                onClick={() => {
                  setHelp({ ...help, paymentType: !help.paymentType });
                }}
              >
                Payment Type
                <i className="xs">
                  <InfoIcon />
                </i>
                <div className={help.paymentType ? "fs-xs" : "hidden"}>
                  Tax % for Payment.
                </div>
              </label>
              <select
                className={inputCls}
                id="paymentType"
                name="paymentType"
                value={eventData?.paymentType || ""}
                onChange={handleChange}
              >
                <option value="">No Payments</option>
                <option value="payment">Inline Payment</option>
                <option value="paymentLink">Payment Link</option>
              </select>
            </div>
            <div className={formGroupCls}>
              <label className="checkbox-container">
                Production Payment
                <input
                  type="checkbox"
                  onChange={(e) => {
                    if (user.email.indexOf("core12.com") > -1) {
                      setEventData({
                        ...eventData,
                        prodPayment: e.target.checked,
                      });
                    } else {
                      alert("Contact a Core12 Admin to update this feature.");
                    }
                  }}
                  id="prodPayment"
                  name="prodPayment"
                  checked={eventData?.prodPayment || false}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            <div className="py-2"></div>
            <div className={formGroupCls}>
              <label className="checkbox-container">
                Allow upload submission
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setEventData({
                      ...eventData,
                      allowUpload: e.target.checked,
                    });
                  }}
                  id="allowUpload"
                  name="allowUpload"
                  checked={eventData?.allowUpload || false}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            <div className={eventData?.allowUpload ? formGroupCls : "hidden"}>
              <label className="checkbox-container">
                Upload submission required
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setEventData({
                      ...eventData,
                      uploadRequired: e.target.checked,
                    });
                  }}
                  id="uploadRequired"
                  name="uploadRequired"
                  checked={eventData?.uploadRequired || false}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            <div className={eventData?.allowUpload ? formGroupCls : "hidden"}>
              <label className={labelCls}>Upload Copy</label>
              <textarea
                id="uploadCopy"
                name="uploadCopy"
                value={eventData?.uploadCopy}
                onChange={handleChange}
                className={inputCls}
              ></textarea>
            </div>
            <div className={eventData?.allowUpload ? formGroupCls : "hidden"}>
              <label
                className={labelCls + " form-help"}
                onClick={() => {
                  setHelp({ ...help, uploadMaxFiles: !help.uploadMaxFiles });
                }}
              >
                Max files to upload{" "}
                <i className="xs">
                  <InfoIcon />
                </i>
              </label>
              <div className={help.submitButton ? "fs-xs" : "hidden"}>
                Maximum number of files to upload with the submission.
              </div>
              <input
                type="number"
                id="uploadMaxFiles"
                name="uploadMaxFiles"
                value={eventData?.uploadMaxFiles || ""}
                onChange={handleChange}
                className={inputCls}
              />
            </div>
            <div className={eventData?.allowUpload ? formGroupCls : "hidden"}>
              <label
                className={labelCls + " form-help"}
                onClick={() => {
                  setHelp({ ...help, uploadMinFiles: !help.uploadMinFiles });
                }}
              >
                Min files to upload{" "}
                <i className="xs">
                  <InfoIcon />
                </i>
              </label>
              <div className={help.submitButton ? "fs-xs" : "hidden"}>
                Minimum number of files to upload with the submission.
              </div>
              <input
                type="number"
                id="uploadMinFiles"
                name="uploadMinFiles"
                value={eventData?.uploadMinFiles || ""}
                onChange={handleChange}
                className={inputCls}
              />
            </div>
            <div className={formGroupCls}>
              <label
                className={labelCls + " form-help"}
                onClick={() => {
                  setHelp({ ...help, submitButton: !help.submitButton });
                }}
              >
                Alternate Submit Button{" "}
                <i className="xs">
                  <InfoIcon />
                </i>
              </label>
              <div className={help.submitButton ? "fs-xs" : "hidden"}>
                Alternate Submit button name. Default Submit if left blank.
              </div>
              <input
                type="text"
                id="submitButton"
                name="submitButton"
                value={eventData?.submitButton || ""}
                onChange={handleChange}
                className={inputCls}
              />
            </div>
            <div className={formGroupCls}>
              <label className="checkbox-container">
                Hide Enter Details Title
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setEventData({
                      ...eventData,
                      hideEnterDetails: e.target.checked,
                    });
                  }}
                  id="hideEnterDetails"
                  name="hideEnterDetails"
                  checked={eventData?.hideEnterDetails || false}
                />
                <span className="checkmark"></span>
              </label>
            </div>
          </div>
        )}
      </div>
      <div className="flex flex-wrap gap-4">
        <div className="w-full">
          <div className={cardCls}>
            <div className={cardHeaderCls}>
              <h2>Event History</h2>
            </div>
            <div className={cardBodyCls}>
              <div>
                <label>Created:</label>
                {eventData?.createdAt
                  ? moment(eventData?.createdAt).format("MM/DD/YYYY h:mm A")
                  : "N/A"}
              </div>
              <div>
                <label>Updated:</label>{" "}
                {eventData?.updatedAt
                  ? moment(eventData?.updatedAt).format("MM/DD/YYYY h:mm A")
                  : "N/A"}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="py-3"></div>
      <div className={floatingSave ? "floating-save" : "pb-4"}>
        <div className="flex flex-wrap gap-4">
          <div className="flex-none">
            <button className={primaryBtnCls} onClick={handleSubmit}
              disabled={!canEditCurrentEvent}>
              Save
            </button>
          </div>
          <div className="flex-none">
            <button
              onClick={() => {
                setCurrentEventData({});
                sessionStorage.removeItem("eventData");
                setEventData({});
                setTimeout(() => {
                  window.location.href = "/manage";
                }, 20);
              }}
              className={secondaryBtnCls}
            >
              Close
            </button>
          </div>
          <ShortcodeReferencePanel fieldList={shortcodeFieldList} />
        </div>
      </div>
      <div className="py-3"></div>
      <div className="py-3"></div>
      <VisualEditorModal
        changeItem={handleChangeItem}
        fieldList={shortcodeFieldList}
        idkey={editCopy}
        onClose={() => setEditCopy(null)}
        value={eventData}
      />
      {eventData?.id && (
        <div className="record-id-badge pointer-events-none fixed bottom-2 left-2 z-10 select-text">
          <div className="pointer-events-auto truncate rounded-md bg-zinc-50/90 px-2 py-1 text-xs text-zinc-600 shadow-sm ring-1 ring-zinc-200 backdrop-blur dark:bg-zinc-900/90 dark:text-zinc-400 dark:ring-zinc-700">
            Id: {eventData?.id}
          </div>
        </div>
      )}
    </div>
  );
};
export default Event;
